const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPayHostingFeeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 48,
    viewBox: "0 0 160 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1631_65293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.207 0.046875C26.207 0.046875 9.83755 3.30811 5.69162 18.7364C5.69162 18.7364 3.73251 1.69479 26.207 0.046875Z",
    fill: "url(#paint0_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.929 33.5885C15.929 33.5885 15.4373 33.3988 14.7053 33.6172C14.5607 33.661 14.4197 33.716 14.2836 33.7817C14.2728 33.8937 14.27 34.0065 14.2751 34.119C11.8691 32.1455 9.48494 29.1997 9.323 25.2798C8.99576 17.3523 12.0369 11.9843 15.6481 9.08745C15.6496 9.08709 15.6523 9.08745 15.6523 9.08745C16.0621 8.75878 16.4907 8.45439 16.936 8.17578C16.8516 8.31158 9.56165 19.5012 14.1959 28.7123C13.7514 28.9484 13.2977 29.3759 13.5389 30.097C13.9699 31.3823 14.8883 31.3368 14.8883 31.3368C14.8883 31.3368 14.4869 32.7941 15.9307 32.9569C15.9282 32.9594 15.6633 33.3372 15.929 33.5885Z",
    fill: "url(#paint1_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8427 47.96C25.8782 47.9684 25.9144 47.9768 25.9524 47.9836C23.9191 47.9929 19.3414 48.062 16.5069 47.0609C15.9368 46.8594 15.3261 46.7236 14.7586 46.5094L14.5612 46.4327C13.8494 46.1004 13.157 45.7349 12.484 45.3363C8.83267 43.1855 5.80622 40.1184 3.70431 36.4387C1.60239 32.7589 0.497848 28.594 0.500003 24.3562C0.500003 10.909 11.4012 0.0078125 24.8493 0.0078125C25.3058 0.0078125 25.7587 0.0204638 26.2079 0.0457644C25.7702 0.0710649 25.335 0.109015 24.9049 0.160459H24.8931H24.862C15.0242 1.34115 7.17429 8.98952 5.69336 18.7311C5.52522 19.8363 5.44065 20.9528 5.44036 22.0707C5.43375 26.3317 6.66614 30.5027 8.98752 34.0759C7.83463 31.7752 7.01237 28.8581 6.85635 25.1768C6.54684 17.8346 11.0006 12.567 15.6475 9.09746C15.6475 9.09746 15.6503 9.0971 15.6517 9.09746C16.079 8.7781 16.5068 8.4742 16.9352 8.18578C13.2102 11.4546 9.92533 17.0301 10.982 26.3972C11.2907 29.138 12.4107 31.3307 14.11 33.0739L14.1151 33.079L14.1328 33.0967C14.2652 33.2342 14.4035 33.3683 14.5452 33.4999L14.5528 33.4881L14.7054 33.6246C14.5608 33.6685 14.4198 33.7235 14.2837 33.7892C14.273 33.9012 14.2701 34.014 14.2753 34.1265C14.2913 34.603 14.4212 35.4919 15.1052 36.2348C15.1052 36.2348 14.0712 36.2871 14.1572 37.0875C14.2433 37.8878 14.5595 38.2201 15.2199 38.2556C15.2199 38.2556 15.9958 38.1712 16.4259 37.817C16.4158 37.8473 16.2091 38.5001 16.9681 39.432C16.9681 39.432 15.3919 40.0097 15.3919 41.6188C15.3919 43.228 16.2791 44.3833 18.0173 44.1219C18.0173 44.1219 18.7763 43.8587 19.3084 43.6302C19.2907 43.669 18.7856 44.773 19.6061 45.2165C20.4394 45.6686 21.4961 45.2688 21.9751 44.6262C21.9591 44.6616 21.6445 45.3456 21.7753 45.7757C21.7753 45.7757 22.4246 47.125 24.7269 46.7624C24.7267 46.7666 24.7267 46.7709 24.7269 46.7751C24.7461 46.9734 24.8105 47.1648 24.9154 47.3342C25.0202 47.5038 25.1627 47.6469 25.3316 47.7525C25.3502 47.7652 25.3696 47.7761 25.389 47.7871C25.4286 47.809 25.4733 47.8301 25.5146 47.8503C25.5391 47.8613 25.5644 47.8723 25.5906 47.8824C25.644 47.9041 25.6986 47.9227 25.7542 47.9381L25.8444 47.9616L25.8427 47.96Z",
    fill: "url(#paint2_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5286 11.4496C41.0049 11.0735 40.3817 11.399 40.0182 11.663C37.6205 5.91133 31.723 1.27205 31.5332 1.12109C33.6315 1.90625 41.3035 8.02814 41.3035 8.02814C41.3035 8.02814 41.5615 9.71483 41.6661 11.1224C41.6788 11.2835 41.6889 11.4403 41.6956 11.5913C41.6452 11.5382 41.5892 11.4908 41.5286 11.4496Z",
    fill: "url(#paint3_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.835 15.88C45.8483 15.6903 44.6634 15.8968 44.4972 15.9272L44.5048 15.9188C44.9822 15.6936 45.2056 15.0045 45.2056 15.0045C45.1821 14.9902 45.2107 14.9674 45.2301 14.9076C45.5599 14.0642 44.8497 13.4191 44.8497 13.4191C43.4515 12.7444 42.6941 13.8517 42.6941 13.8517C42.8948 12.924 41.8609 12.5074 41.963 12.2493C42.065 11.9913 41.715 11.6202 41.715 11.6202C41.715 11.6202 41.699 11.6025 41.6906 11.5941C41.6416 11.5401 41.587 11.4914 41.5278 11.449V11.4541C39.7036 7.74333 35.3122 3.18415 31.5332 1.12891C34.8523 2.16377 37.9075 3.906 40.4883 6.23552C43.0692 8.56505 45.1142 11.4265 46.4825 14.6225L46.835 15.88Z",
    fill: "url(#paint4_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.139 9.00908C26.1141 8.94548 26.0755 8.88819 26.0257 8.84134C25.976 8.7945 25.9165 8.75934 25.8514 8.73835C25.8004 8.7231 25.7477 8.71429 25.6946 8.71221C25.6239 8.70634 25.5531 8.72088 25.4904 8.75404C25.4278 8.7872 25.376 8.83769 25.3412 8.89943C25.3327 8.91383 25.3243 8.92901 25.3167 8.94498C25.2864 8.9992 25.2684 9.05943 25.264 9.12138C25.2596 9.18334 25.269 9.24551 25.2914 9.30345C25.2951 9.31376 25.2999 9.32364 25.3057 9.33295C25.31 9.34055 25.3142 9.34814 25.3193 9.35573L25.3361 9.38101L25.3538 9.40379V9.40801L25.3749 9.43079C25.3913 9.44784 25.4088 9.46395 25.4272 9.47885C25.5016 9.54023 25.594 9.57547 25.6904 9.57919C25.7484 9.57969 25.8059 9.56795 25.859 9.5446C25.9173 9.49031 25.9808 9.44196 26.0487 9.40042C26.1151 9.32329 26.1526 9.22552 26.155 9.12382C26.155 9.085 26.1496 9.0464 26.139 9.00908ZM35.4252 26.1292C34.4342 26.7195 33.4112 27.2053 32.2128 27.1041C31.7252 27.0676 31.2711 26.8418 30.9478 26.4749C32.6159 27.0197 34.0008 26.4926 35.3214 25.6383C34.6619 25.6307 34.01 25.6105 33.3986 25.3238C34.5338 25.4924 35.6579 25.5953 36.6792 24.886C36.4262 24.951 36.3081 24.7714 36.1732 24.6331C35.4709 23.9075 34.6948 23.2574 33.8574 22.6933C32.3444 21.7041 30.7117 21.1036 28.8816 21.0833C27.7414 21.0707 26.6627 21.3203 25.6187 21.758C25.4842 21.8275 25.33 21.8486 25.1818 21.818C24.5915 21.6585 24.0922 21.3693 23.7481 20.8565C22.9672 19.7036 22.9528 18.4918 23.4588 17.2512C23.7869 16.4483 24.3216 15.7669 24.8276 15.0728C25.4702 14.1898 25.811 13.2545 25.391 12.1405C25.5596 12.1616 25.687 12.1692 25.8126 12.1953C26.1258 12.2588 26.4373 12.3271 26.7471 12.4002C26.8879 12.434 26.9503 12.3749 26.9798 12.2467C27.0093 12.1185 26.9401 12.0781 26.8213 12.062C26.4544 12.0198 26.0884 11.9693 25.7249 11.9237C25.6086 11.9094 25.4871 11.9136 25.3673 11.8166C25.8834 11.7475 26.3667 11.6707 26.8533 11.6235C27.0363 11.6058 27.0338 11.5088 27.0313 11.384C27.0313 11.2153 26.909 11.2549 26.8162 11.2752C26.6214 11.3165 26.43 11.373 26.2351 11.4169C25.9079 11.4894 25.5798 11.5577 25.2518 11.6277C25.4653 11.475 25.6953 11.3469 25.9374 11.2457C26.1803 11.1302 26.4198 11.0062 26.6602 10.8856C26.7496 10.8409 26.8626 10.8012 26.7875 10.668C26.7226 10.5532 26.6408 10.4824 26.4982 10.5836C26.37 10.6772 26.2267 10.7523 26.0892 10.8324C25.7574 11.0422 25.4007 11.2099 25.0275 11.3317C25.0795 11.2483 25.1457 11.1747 25.2231 11.1141C25.5447 10.8454 25.8672 10.5772 26.1904 10.3095C26.2748 10.2395 26.3811 10.183 26.2537 10.0515C26.1508 9.94353 26.0808 9.96043 25.9855 10.0608C25.8557 10.1991 25.7123 10.3239 25.5731 10.452C25.3201 10.6908 25.057 10.9278 24.7997 11.1647C24.8411 10.8813 25.0097 10.684 25.175 10.4959C25.3614 10.2842 25.4829 10.0253 25.6457 9.79513C25.7038 9.71076 25.6726 9.68462 25.6726 9.68462C25.5276 9.57668 25.4297 9.61966 25.3834 9.65511L25.3555 9.68211C25.3057 9.74048 25.2619 9.8038 25.2248 9.87098C25.0258 10.1931 24.8267 10.5161 24.6193 10.8341C24.5678 10.9134 24.535 11.0441 24.3663 11.007C24.5249 10.6039 24.6851 10.2201 24.8251 9.82628C24.8723 9.69221 25.0157 9.47713 24.8166 9.41647C24.6328 9.35996 24.61 9.61629 24.5577 9.7538C24.438 10.0717 24.3241 10.3922 24.2263 10.7169C24.1698 10.9033 24.0913 10.9851 23.8737 10.9859C23.1206 10.9859 22.5185 11.2904 22.128 11.9557C22.0112 12.1649 21.8215 12.3237 21.595 12.4019C21.089 12.5892 20.7652 12.9746 20.7314 13.3642C21.3015 13.1263 21.8658 13.1761 22.4241 13.3903C22.9419 13.5894 23.4673 13.7327 24.0812 13.6239C23.9896 13.9405 23.8349 14.2354 23.6266 14.4909C23.3475 14.835 23.0136 15.1226 22.688 15.4186C20.6412 17.2655 19.6207 19.535 19.9151 22.3088C20.2094 25.0826 21.5436 27.2111 24.0289 28.5023C26.8516 29.9689 29.8009 30.0423 32.7712 28.967C34.2832 28.4197 35.5238 27.4802 36.4178 26.1191C36.6109 25.8373 36.7414 25.5176 36.8007 25.1812C36.3132 25.5236 35.8865 25.8533 35.4252 26.1266V26.1292ZM22.6425 12.8885C22.9419 12.0064 23.6545 12.0587 24.3924 12.1295C24.0753 12.7881 23.426 13.0664 22.6425 12.8818V12.8885ZM25.3108 27.3098C24.2195 26.3644 24.2086 24.208 25.3319 23.3081C25.746 22.9767 26.2596 22.7751 26.7378 22.5196C26.8753 22.4454 27.0093 22.5483 27.1468 22.5542C27.2059 22.5542 27.2624 22.5913 27.3214 22.5946C27.5078 22.6048 27.7548 22.6832 27.8544 22.5103C27.9539 22.3374 27.7026 22.2387 27.609 22.1004C28.142 22.1232 28.368 22.3897 28.1993 22.7996C28.3275 22.8443 28.4523 22.8915 28.5847 22.9312C28.8647 23.0155 29.0907 22.9202 29.1835 22.6461C29.2679 22.388 29.0376 22.3088 28.8782 22.2C28.7188 22.0912 28.5063 22.1553 28.3081 22.0465C28.6286 21.9217 28.9153 21.9132 29.197 22.0507C29.7148 22.3037 29.7384 22.6495 29.2459 23.002C29.4787 23.1327 29.6735 23.2947 29.7368 23.5612C29.7545 23.6345 29.7654 23.7104 29.8615 23.6859C29.9973 23.6522 30.1348 23.6075 30.209 23.4751C30.2188 23.4573 30.2248 23.4376 30.2267 23.4173C30.2284 23.3971 30.226 23.3767 30.2195 23.3575C30.213 23.3382 30.2026 23.3204 30.1888 23.3055C30.1752 23.2904 30.1585 23.2784 30.1398 23.2702C30.0226 23.1985 29.8995 23.1361 29.7368 23.0458C29.9113 23.0458 30.0429 23.0458 30.1753 23.0458C30.2251 23.0534 30.276 23.0456 30.3212 23.0234C30.3664 23.0013 30.4038 22.9658 30.4283 22.9219C30.4545 22.8732 30.4647 22.8176 30.4576 22.7629C30.4505 22.7081 30.4263 22.6569 30.3887 22.6166C30.3391 22.5471 30.2757 22.4888 30.2024 22.4452C30.129 22.4017 30.0475 22.3738 29.9627 22.3636C29.8574 22.3484 29.7527 22.3316 29.6086 22.3096C29.994 22.0853 30.4604 22.1569 30.6864 22.4782C30.7917 22.6259 30.877 22.6469 31.0473 22.6216C31.3172 22.5744 31.5949 22.635 31.8207 22.7903C31.9941 22.9293 32.1997 23.0224 32.4186 23.061C31.8662 23.0003 31.9058 23.6716 31.474 23.7712C31.8957 23.729 32.223 23.9398 32.5704 24.0596C33.0764 24.2333 33.5942 24.1818 34.1095 24.0866L34.3718 24.0393C33.8751 24.4357 33.3598 24.3961 32.8445 24.3345C32.8622 24.7562 32.7045 24.9527 32.2238 25.1154C32.1124 25.1542 32.0121 25.1542 32.0087 25.333C31.9994 25.9234 31.496 26.313 30.9124 26.1713C30.6324 26.103 30.4705 26.1039 30.3077 26.3957C30.1053 26.7566 29.6246 26.8266 29.2113 26.6166C29.0566 26.5273 28.9068 26.4296 28.7626 26.324C28.3832 27.0484 27.5592 26.9868 26.8761 26.1831C26.3186 26.5778 25.8953 26.4058 25.5756 26.1055C25.1734 25.7269 25.0115 25.0285 25.3226 24.5656C25.5706 24.1962 25.4567 23.9322 25.2661 23.6075C24.8006 24.2906 24.7601 25.0243 24.9465 25.7842C25.0301 26.1543 25.1925 26.502 25.4226 26.8037C25.6527 27.1054 25.945 27.354 26.2799 27.5325C25.8995 27.6371 25.6187 27.5679 25.3142 27.3022L25.3108 27.3098ZM30.0715 28.3362C29.9923 28.332 29.913 28.321 29.8329 28.3168C29.5495 28.3008 29.2956 28.1701 29.0275 28.1119C28.7593 28.0537 28.6058 28.3944 28.3199 28.4492C28.1039 28.4904 27.8815 28.4851 27.6677 28.4335C27.4539 28.3819 27.2536 28.2851 27.0802 28.1498C26.6231 27.8125 26.3102 27.3714 26.2141 26.8005C26.1997 26.7161 26.1298 26.5812 26.2647 26.5424C26.365 26.5129 26.4013 26.6368 26.4426 26.7111C26.6256 27.0484 26.8213 27.3731 27.1047 27.632C27.442 27.9365 27.8097 28.1625 28.2921 28.0604C28.4886 28.0191 28.5906 27.9499 28.3857 27.7611C28.228 27.6159 28.0585 27.4709 27.9708 27.2601C28.0158 27.2171 28.0751 27.1922 28.1373 27.1902C28.1995 27.1881 28.2604 27.2091 28.3081 27.2491C29.4888 28.1144 30.7539 28.0924 32.0686 27.6193C32.0989 27.6112 32.1296 27.6048 32.1605 27.6C31.7456 28.0461 30.8171 28.3708 30.0715 28.3286V28.3362Z",
    fill: "url(#paint5_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0862 30.3526C36.9639 30.0818 36.8593 29.8035 36.7489 29.5294C36.8146 30.1459 36.9066 30.7455 36.8939 31.3578C36.8813 31.9954 36.7176 32.7409 36.4806 33.1289C36.7927 31.7255 36.6493 30.3568 36.2572 29.0066C36.0844 28.4319 36.058 27.823 36.1804 27.2355C36.2091 27.0947 36.3086 26.9674 36.2648 26.7852C35.9002 27.2805 35.4976 27.7466 35.0605 28.1793C34.9651 28.272 34.9686 28.3479 35.0158 28.4685C35.286 29.1493 35.3979 29.8827 35.343 30.6132C35.2696 31.6817 34.8935 32.6532 34.4237 33.5986C33.9338 34.5837 33.3274 35.4784 32.484 36.2029C31.9974 36.6245 31.4535 36.94 30.7973 36.956C30.5443 36.9627 30.401 37.015 30.2972 37.2672C30.169 37.5784 29.8899 37.7513 29.5593 37.8238C29.0591 37.9343 28.5473 37.6239 28.4477 37.1492C28.3634 36.7418 28.6873 36.3252 29.1747 36.2029C29.5121 36.1185 29.8317 36.2029 30.1471 36.2931C30.4539 36.3876 30.7773 36.4163 31.0959 36.3774C31.4146 36.3384 31.7215 36.2327 31.9966 36.0671C32.6957 35.6598 33.2194 35.0761 33.6394 34.3956C33.7588 34.2268 33.8447 34.0367 33.8925 33.8356C33.6471 34.1002 33.3771 34.3407 33.0862 34.5542C32.721 34.8071 32.4174 34.9581 32.1762 34.9758L32.7303 34.5913C31.7689 34.8906 30.7804 34.8206 29.8115 34.9286C28.8053 35.0365 27.8136 35.228 26.944 35.8107C26.374 36.1944 25.9202 36.6752 25.69 37.3288C25.3931 38.178 25.7743 38.9033 26.6404 39.1453C27.1608 39.2904 27.6904 39.2677 28.2175 39.1875C28.4832 39.1462 28.753 39.1031 29.0077 38.9497C28.7905 38.9324 28.5745 38.902 28.3609 38.8586C27.7056 38.69 27.1338 38.3965 26.982 37.6517C26.8336 36.9274 27.1423 36.3698 27.7115 35.965C28.5017 35.4101 29.4083 35.5231 30.2964 35.5864C30.0596 35.6141 29.8213 35.6279 29.5829 35.6277C29.0921 35.6505 28.6054 35.7121 28.1702 35.965C27.3708 36.4365 27.2721 37.4182 27.9603 38.0414C28.3474 38.3914 28.8138 38.4994 29.3215 38.4774C30.1075 38.4437 30.7551 38.0718 31.3641 37.6239C31.9118 37.2181 32.4219 36.7636 32.888 36.2661C32.8872 36.3068 32.874 36.3463 32.8501 36.3792C32.1652 37.3844 31.2477 38.1333 30.2019 38.7237C28.8323 39.4945 27.3396 39.82 25.7811 39.8749C24.3811 39.9271 23.0595 39.6581 21.8367 38.9472C21.6278 38.8288 21.4074 38.7321 21.1789 38.6587C20.4663 38.4226 19.7561 38.684 19.3066 39.3671C20.2588 39.1672 20.9933 39.6319 21.7439 40.0503C22.5371 40.5051 23.4308 40.7557 24.3449 40.7797C24.6442 40.7857 24.9436 40.7797 25.243 40.7797C23.9779 41.3701 23.8093 41.4713 23.4551 41.9149C22.9541 42.5423 22.8015 43.4642 23.127 43.901C23.1861 43.255 23.3944 42.6882 23.9779 42.286C23.7638 43.2491 24.0143 43.836 24.6248 43.8538C24.3912 42.5888 24.8947 41.5261 25.9059 41.2107C25.5972 41.5767 25.3636 41.9487 25.3282 42.4176C25.2776 43.0821 25.7178 43.6548 26.32 43.6944C26.4583 43.7028 26.5434 43.6944 26.4634 43.5198C26.1058 42.7422 26.3629 42.1022 27.0487 41.5472C27.386 41.274 27.7697 41.0826 28.145 40.8784L29.658 40.0663C29.1722 40.6566 28.8382 41.2984 28.829 42.0676C28.7202 42.0946 28.7598 41.9192 28.6467 41.9621C28.6122 42.2675 28.6274 42.582 28.4503 42.8578C28.2403 43.1859 27.908 43.3191 27.5816 43.1951C27.2552 43.0711 27.0832 42.7026 27.1819 42.3273C27.271 41.9643 27.4873 41.6453 27.7916 41.4283C27.9603 41.3069 28.1289 41.1871 28.2977 41.0665C27.9363 41.1425 27.6022 41.315 27.3311 41.5658C27.0039 41.8854 26.8142 42.2742 26.8656 42.7465C26.9204 43.2525 27.2772 43.6522 27.7359 43.7272C27.9643 43.7667 28.1994 43.7279 28.4029 43.6171C28.6066 43.5062 28.7668 43.33 28.8576 43.1167C28.8972 43.0062 28.9307 42.8936 28.9579 42.7793C29.0379 42.8527 29.1224 42.9209 29.211 42.9835C29.3999 43.0998 29.6099 43.1437 29.8106 43.0366C30.0114 42.9295 30.0341 42.7178 29.997 42.5103C29.9616 42.2938 29.9149 42.0793 29.857 41.8677C29.5972 40.9662 29.835 40.2653 30.6025 39.6902C31.7478 38.8468 32.7502 37.8248 33.5711 36.6634C34.4181 35.4722 35.066 34.1515 35.4898 32.7527C35.6922 32.0671 35.736 31.3545 35.8414 30.6528C36.0101 32.816 35.3354 34.7481 34.1961 36.5453C33.5694 37.5328 32.7235 38.3341 31.8911 39.1395C31.5918 39.4287 31.3455 39.7517 31.2806 40.1801C31.2541 40.3205 31.259 40.465 31.2948 40.6033C31.3306 40.7415 31.3965 40.8701 31.4878 40.98C31.5791 41.0899 31.6935 41.1782 31.8228 41.2388C31.9522 41.2994 32.0932 41.3307 32.2361 41.3305C32.5658 41.3381 32.8812 41.2647 33.2295 41.1769C32.6594 41.0462 32.4342 40.8051 32.4706 40.3961C32.9428 41.155 33.9827 41.1643 34.4709 40.4087C34.4904 40.3792 34.5022 40.2999 34.5317 40.3244C34.7307 40.5208 34.7476 40.2763 34.8015 40.2046C35.4981 39.2887 35.7005 38.2177 35.7503 37.1028C35.7738 36.8885 35.7514 36.6717 35.6846 36.4668C35.6002 36.6448 35.5395 36.789 35.4737 36.9316C35.1701 37.5927 34.7147 38.1494 34.2761 38.7211C34.1649 38.863 34.0816 39.0247 34.0308 39.1976C34.0202 39.2203 34.0181 39.246 34.0247 39.2701C34.0313 39.2942 34.0463 39.3151 34.067 39.3292C34.0884 39.3423 34.1136 39.3478 34.1385 39.3449C34.1634 39.342 34.1867 39.3308 34.2044 39.3131C34.2938 39.2432 34.3529 39.1234 34.5165 39.1268C34.5013 39.6092 34.4465 40.0655 34.0805 40.4213C33.8115 40.6828 33.4117 40.741 33.1528 40.5571C32.8627 40.353 32.8012 40.0334 32.9766 39.6513C33.0887 39.4388 33.2352 39.2462 33.41 39.0812L34.0585 38.3973C33.7355 38.4749 33.5525 38.6697 33.2996 38.6925C33.7643 38.3113 34.2677 37.9832 34.6607 37.5202C35.0976 37.0058 35.4939 36.3125 35.5175 35.9735C34.8496 36.7991 34.5536 37.0741 34.1581 37.1989C35.0933 36.1987 35.7655 35.0652 36.5937 34.0574C37.5467 32.8969 37.6909 31.6927 37.0862 30.3526ZM34.6809 39.1479C34.7442 39.4692 34.67 39.7129 34.6287 39.9625C34.603 39.6899 34.6206 39.415 34.6809 39.1479Z",
    fill: "url(#paint6_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7062 32.6899C46.5848 32.0582 46.2162 31.5581 45.8148 31.0833C45.2953 30.4677 44.6552 30.0536 43.8287 29.9701C43.6786 29.9549 43.5091 29.9389 43.3683 29.8199C43.5192 29.7668 43.6415 29.8494 43.8532 29.8309C41.6385 28.8417 39.4871 27.9047 37.1999 27.311C37.3046 27.4569 37.469 27.5159 37.6149 27.5944C38.2398 27.9317 38.8799 28.2302 39.4913 28.5937C40.2875 29.0711 40.8281 29.7399 40.7968 30.7307C40.7859 31.0909 40.678 31.4282 40.333 31.618C40.1365 31.7268 39.9291 31.758 39.7866 31.5177C39.7165 31.4013 39.7089 31.3102 39.8885 31.3059C40.1213 31.2992 40.2428 31.1466 40.3313 30.9551C40.4009 30.7994 40.4389 30.6315 40.4434 30.4609C40.4479 30.2905 40.4187 30.1208 40.3574 29.9617C40.1045 29.2144 38.9996 28.3019 38.1766 28.1754C38.5577 28.4967 38.9499 28.775 39.278 29.1276C39.5402 29.4101 39.7528 29.7179 39.8186 30.1084C39.8498 30.299 39.8127 30.4753 39.6499 30.5891C39.4871 30.703 39.2864 30.6735 39.1119 30.5765C38.9701 30.4986 38.8605 30.3731 38.8023 30.2222C38.7239 30.0173 38.6379 29.8149 38.5713 29.6057C38.4026 29.0711 37.7532 28.1172 37.3493 27.844C37.6562 28.35 37.9118 28.8358 38.0669 29.3696C37.6141 28.6486 37.2168 27.8937 36.6628 27.2148C36.5 28.0371 36.5362 28.4655 36.8618 29.1714C37.3309 30.1537 37.7292 31.1684 38.0535 32.2075C38.4549 33.5569 38.8968 34.9163 38.524 36.372C39.2055 35.8187 39.4871 35.3827 39.5453 34.6692C39.5833 34.2003 39.5773 33.7196 39.1008 33.4194C39.0694 33.4033 39.0446 33.3767 39.0307 33.3442C39.0168 33.3116 39.0148 33.2753 39.025 33.2414C39.1195 32.8831 38.9305 32.603 38.7644 32.3137C38.5744 32.0069 38.4091 31.6855 38.2702 31.3524C38.5872 31.7007 38.8606 31.9933 39.1236 32.291C39.3168 32.5085 39.4399 32.7489 39.3623 33.0559C39.2915 33.3376 39.3539 33.4236 39.6533 33.4405C39.8638 33.4583 40.0756 33.4267 40.2719 33.3483C40.468 33.2698 40.6432 33.1465 40.7834 32.9884C41.5137 32.1847 41.6613 31.2537 41.3922 30.2054L42.3039 31.4274C42.7703 32.0675 43.192 32.7455 43.951 33.0913C44.8584 33.5037 45.6917 33.0415 45.7971 32.0144C45.9556 32.3265 46.0145 32.6797 45.9658 33.0264C45.9499 33.2005 45.8938 33.3685 45.8021 33.5173C45.7104 33.6662 45.5854 33.7916 45.437 33.8841C46.2871 34.0924 46.8673 33.5274 46.7062 32.6899ZM40.9992 29.0129C41.48 29.3232 41.9649 29.6285 42.4406 29.9465C42.6725 30.1016 42.8876 30.2838 43.1102 30.4525C43.4635 30.7207 43.5968 31.1111 43.7275 31.5303C43.5209 31.419 41.1333 29.2549 40.9992 29.0129ZM44.753 31.688C44.6512 31.7441 44.5331 31.7634 44.4187 31.7427C44.3042 31.7219 44.2005 31.6624 44.1247 31.5742C43.9579 31.3867 43.8441 31.1582 43.795 30.9121C43.7566 30.7339 43.6957 30.5613 43.6137 30.3985C43.8321 30.3985 44.0016 30.3985 44.1703 30.3985C44.3716 30.4042 44.5646 30.4804 44.7156 30.6136C44.8665 30.7469 44.9661 30.9289 44.9967 31.128C45.0347 31.3625 44.9858 31.5758 44.7556 31.688H44.753Z",
    fill: "url(#paint7_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8951 33.4521C43.6277 33.2834 43.3629 33.1046 43.0897 32.9258C43.6269 33.9319 44.5234 34.5982 45.225 35.4474L43.9313 34.5028C44.111 34.852 44.251 35.1354 44.402 35.4137C44.5529 35.692 44.7874 35.9197 44.9999 36.1609C45.2815 36.4788 45.5194 36.8187 45.6206 37.2404C45.7674 37.8518 45.4519 38.4514 44.8928 38.6024C44.3218 38.7585 43.7222 38.3933 43.562 37.7793C43.4776 37.4639 43.5139 37.1443 43.5747 36.828C43.6792 36.279 43.7483 35.7317 43.5586 35.1775C43.4667 35.8523 43.1698 36.4679 43.0374 37.1291C43.0432 36.77 43.0999 36.4137 43.2061 36.0706C43.3174 35.649 43.4937 35.2172 43.4059 34.7778C43.1884 33.6814 42.6469 32.7301 41.9723 31.8506C41.9723 31.8506 41.9571 31.8506 41.9064 31.8438C42.5053 32.7884 42.8915 33.775 42.7971 34.8967C42.6376 33.8704 42.3037 32.9199 41.6703 32.1247C41.1281 32.6922 41.2537 33.2868 41.5759 33.8873C41.5962 33.933 41.6126 33.9804 41.6248 34.0289C41.9622 35.0586 42.0558 36.1373 42.2927 37.1915C42.4968 38.0939 42.7726 38.9701 43.4608 39.6448C44.2476 40.4156 45.4781 40.2917 46.0448 39.3749C46.3467 38.8875 46.415 38.3469 46.3341 37.7861C46.3004 37.5516 46.2497 37.3197 46.205 37.086C46.4074 37.3949 46.5523 37.7377 46.6326 38.0981C46.659 38.0728 46.68 38.0423 46.6945 38.0087C46.709 37.9751 46.7166 37.939 46.717 37.9024C46.873 37.0987 46.7034 36.3541 46.3004 35.6557C45.7285 34.6732 44.8245 34.0483 43.8951 33.4521Z",
    fill: "url(#paint8_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7773 27.4353C42.2712 27.087 41.7163 26.8753 41.1471 26.6965C39.8525 26.2892 38.5378 26.2698 37.2137 26.5582C38.3412 25.9358 38.9923 25.1616 39.1061 24.2617C39.0083 24.3537 38.9375 24.4304 38.8531 24.4987C38.4981 24.809 38.1321 25.1043 37.68 25.2636C37.5721 25.3016 37.4591 25.38 37.3427 25.3016C37.2263 25.2232 37.1985 25.2949 37.1841 25.4003C37.121 25.7965 36.9775 26.1756 36.7625 26.5144C36.6671 26.6695 36.7169 26.7336 36.8468 26.8188C37.2269 27.0613 37.646 27.2362 38.0857 27.3358C39.8508 27.7937 41.5341 28.465 43.1854 29.2316C44.2379 29.7191 45.3065 30.1795 46.5141 30.0885C47.0708 30.0472 47.6265 29.9729 48.2767 30.0269C47.8292 29.6437 47.3033 29.3628 46.7359 29.2038C45.8394 28.9289 44.9404 28.6615 44.0634 28.325C43.0463 27.9345 42.014 27.5905 40.9337 27.4167C40.3484 27.3223 39.7614 27.2371 39.1753 27.1469C40.3905 27.0363 41.5941 27.0928 42.7773 27.4353Z",
    fill: "url(#paint9_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0939 43.6459C32.6073 44.1012 32.4412 44.7422 31.979 45.2271C31.9605 45.0272 32.1139 44.9151 32.1173 44.7524C31.4899 44.8097 30.913 44.9454 30.4399 45.3747C30.6701 44.8266 30.9653 44.5465 31.5287 44.313C31.8323 44.1864 32.1604 44.1046 32.4243 43.8997C33.3073 43.2141 34.0553 42.4087 34.5394 41.3789C34.326 41.6269 34.1127 41.8757 33.8985 42.1228C33.2635 42.8548 32.496 43.3135 31.5 43.3709C30.3429 43.4384 29.5257 44.0152 29.1159 45.1141C28.7785 46.0131 28.8873 46.9299 29.045 47.8719C29.3773 47.6256 29.7399 47.5177 30.1026 47.4097C30.3902 47.3254 30.6777 47.2411 30.9636 47.1525C32.1089 46.7882 32.7709 45.9895 33.0155 44.8308C33.1068 44.4428 33.1333 44.0424 33.0939 43.6459Z",
    fill: "url(#paint10_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1663 43.5474C38.1663 43.3264 38.0904 43.3163 37.9403 43.3711C37.5382 43.5043 37.1856 43.7557 36.9283 44.0922C37.0354 43.5541 37.3061 43.1367 37.7801 42.86C37.99 42.7424 38.1799 42.5921 38.3426 42.4148C38.983 41.6853 39.5002 40.8564 39.8741 39.9606C39.9761 39.7177 40.0639 39.469 40.1584 39.2227C39.6245 39.9227 39.094 40.6108 38.6614 41.3656C38.5424 41.5846 38.3586 41.7614 38.1351 41.8717C38.2861 41.638 38.4649 41.428 38.5694 41.1632C38.1899 41.4449 37.7388 41.5849 37.3373 41.8151C37.118 41.9348 36.9093 42.0728 36.7132 42.2275C35.5874 43.1553 35.0316 45.3058 36.44 46.9191C36.6119 46.6416 36.8307 46.3962 37.0869 46.1938C37.3584 45.9737 37.6392 45.7646 37.9074 45.5403C38.8452 44.7526 39.2365 43.3998 38.873 42.2031C38.5787 42.6011 38.4598 43.0878 38.1663 43.5474Z",
    fill: "url(#paint11_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8169 34.8971C41.058 36.7981 40.8447 38.629 39.9305 40.3342C39.5512 41.0296 39.3673 41.8147 39.3984 42.6062C39.4178 43.1966 39.4203 43.7869 39.1875 44.4236C40.8531 42.8558 41.7791 39.8645 41.7775 37.407C41.7841 36.0031 41.4359 34.6202 40.7654 33.3867C40.6718 33.8977 40.7537 34.3979 40.8169 34.8971Z",
    fill: "url(#paint12_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5664 12.4502C34.6584 12.5836 35.7187 12.9067 36.6995 13.4049C37.0706 13.5887 37.445 13.7667 37.8364 13.9556C37.8051 13.7869 37.6854 13.727 37.5918 13.6494C36.6641 12.8803 35.6082 12.3515 34.4714 11.9796C33.9899 11.8219 33.526 11.6321 33.1119 11.3227L34.5228 11.6178C34.107 11.2417 33.8811 10.8141 33.5876 10.4371C34.2403 10.9372 34.8298 11.5107 35.5273 11.9552C35.3249 11.6077 35.1545 11.2501 34.9749 10.8967C34.748 10.4585 34.4126 10.0857 34.0008 9.81389C33.0604 9.17459 32.0231 9.22351 30.9647 9.38545C30.8298 9.4065 30.8804 9.48665 30.8804 9.5592C31.012 11.1118 32.0611 12.2714 33.5664 12.4502Z",
    fill: "url(#paint13_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4924 14.5519C37.1945 14.0956 35.9041 14.3832 35.1855 15.7848C35.6009 15.4991 36.0724 15.3053 36.5687 15.2164C37.6321 15.0224 38.4873 15.477 39.2607 16.1171C40.3857 17.0448 41.2003 18.2356 41.9189 19.4905C42.3499 20.2411 42.6678 21.0355 42.7462 21.9093C42.7833 22.3309 42.8137 22.7526 42.8516 23.2249C43.1851 22.4104 43.2702 21.5154 43.0962 20.6527C42.7783 18.9077 41.9357 17.4361 40.7432 16.1492C40.1049 15.4627 39.3981 14.8732 38.4924 14.5519Z",
    fill: "url(#paint14_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.6909 22.3455C43.486 22.7504 43.3797 23.1975 43.1621 23.5999C43.9853 22.936 44.7096 22.1658 45.6078 21.5989C45.2283 21.965 44.9745 22.4264 44.5798 22.8525C45.0402 22.7124 45.4476 22.7015 45.8558 22.6888C45.1516 23.0903 44.3378 23.2304 43.663 23.7239C44.2753 23.6615 44.8843 23.7315 45.4923 23.7188C46.14 23.7053 46.7295 23.5307 47.2372 23.1055C47.8571 22.5859 48.1387 21.8756 48.385 21.1408C48.433 20.9966 48.3201 21.0008 48.2391 20.9772C47.8482 20.8561 47.4491 20.7631 47.0449 20.6988C45.6601 20.5006 44.2889 21.1645 43.6909 22.3455Z",
    fill: "url(#paint15_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3974 25.8958C47.1126 25.658 46.7768 25.4891 46.416 25.4025C46.0553 25.3158 45.6794 25.3138 45.3177 25.3964C44.2981 25.6015 43.3679 26.089 42.3483 26.2982C42.8648 26.3176 43.3801 26.3646 43.8916 26.4391C44.5342 26.542 45.176 26.6627 45.7031 26.116C45.7346 26.0914 45.7707 26.0733 45.8094 26.0629C46.0036 25.9798 46.2194 25.9614 46.4249 26.0105C46.6304 26.0595 46.8147 26.1734 46.9504 26.3354C47.3207 26.7757 47.1385 27.3646 46.5844 27.5164C46.1256 27.6421 45.7275 27.4886 45.3978 27.1882C45.1001 26.9157 44.7518 26.8027 44.3732 26.7436C43.5913 26.6221 42.802 26.6221 42.0117 26.6593C43.0726 27.0035 44.0299 27.5644 45.0251 28.0436C46.6164 28.8088 48.3613 28.2385 49.2022 26.6736C48.4625 26.7057 47.9245 26.3177 47.3974 25.8958Z",
    fill: "url(#paint16_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7128 37.9537C36.7642 37.4705 36.7617 37.4815 36.3333 37.3052C36.1385 37.2259 36.0752 37.2589 36.0542 37.4671C35.9003 39.1053 35.3466 40.6807 34.4417 42.055C33.9696 42.7521 33.6592 43.546 33.5334 44.3784C33.4489 45.0645 33.2263 45.7263 32.8789 46.324C33.3539 46.0421 33.7795 45.6843 34.1389 45.2648C35.0009 44.221 35.6483 43.0173 36.044 41.7227C36.4235 40.4982 36.5779 39.2264 36.7128 37.9537Z",
    fill: "url(#paint17_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8172 19.5783C37.3384 19.5573 37.836 19.3962 38.4119 19.2604C37.9372 19.2309 37.5382 19.214 37.1402 19.176C36.6924 19.1381 36.274 19.0167 35.9704 18.6541C35.8661 18.5251 35.8024 18.3682 35.7874 18.203C35.7724 18.0378 35.8068 17.872 35.8861 17.7263C36.0548 17.4413 36.3078 17.3544 36.6258 17.3755C36.7691 17.3856 36.8787 17.4868 37.0719 17.5265C36.8627 17.244 36.597 17.1259 36.296 16.9631C36.4555 16.9341 36.6198 16.9523 36.7691 17.0154C37.2751 17.2322 37.5661 17.6243 37.7238 18.1387C37.9608 18.9079 38.1547 19.0504 38.9888 19.0808C38.9045 19.0319 38.8362 18.9905 38.767 18.9534C38.3453 18.7299 38.1227 18.3631 38.0426 17.9085C37.9422 17.3417 38.3133 17.0028 38.8783 17.1166C39.1625 17.1806 39.4172 17.3376 39.6019 17.5628C39.9477 17.9507 40.0236 18.4432 40.1079 18.9205C40.1729 19.3143 40.4183 19.5682 40.6452 19.8482C40.4891 19.0319 40.3171 18.2239 39.8676 17.5079C39.268 16.5515 38.3808 16.0743 37.2464 15.9258C37.4792 16.3475 37.5594 16.7691 37.5838 17.287C36.9935 16.5035 36.2159 16.382 35.3768 16.4116C34.9997 16.4242 34.6237 16.5086 34.2424 16.4192C34.0813 16.382 34.1378 16.5296 34.1412 16.6005C34.1809 17.4017 34.4136 18.1362 34.9407 18.7518C35.1659 19.0281 35.4534 19.2471 35.7796 19.3908C36.1057 19.5344 36.4613 19.5988 36.8172 19.5783Z",
    fill: "url(#paint18_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0781 42.4247C17.0018 42.2103 16.9932 41.9775 17.0536 41.7581C17.1139 41.5386 17.2402 41.3429 17.4154 41.1976C18.0176 40.6663 18.7175 40.4774 19.4985 40.7481C19.7507 40.8515 19.9975 40.9675 20.2381 41.0956C20.0114 40.816 19.7257 40.59 19.4015 40.4336C19.097 40.2817 18.7597 40.2294 18.3701 40.1561C18.5775 40.0746 18.8032 40.0516 19.0228 40.0895C19.5828 40.1451 19.991 40.4867 20.4043 40.8181C20.5982 40.9742 20.7846 41.1554 21.0426 41.1917C21.7233 41.2912 22.3921 41.1917 23.1384 41.0593L22.6037 40.9244C21.8894 40.7388 21.2805 40.3214 20.6184 40.0228C19.5947 39.5598 18.5446 39.3068 17.4289 39.6931C16.2246 40.1097 15.5854 41.5358 16.1116 42.6448C16.5797 43.6264 17.7502 43.8778 18.5059 43.3963C18.3872 43.3916 18.2689 43.3798 18.1516 43.3608C17.6313 43.2394 17.2434 42.9468 17.0781 42.4247Z",
    fill: "url(#paint19_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5557 44.1211C28.03 44.3221 27.4635 44.3933 26.9044 44.3286C26.3495 44.2662 25.7937 44.2063 25.2371 44.176C24.1551 44.1177 23.2628 44.4847 22.6228 45.3907C22.5291 45.5223 22.5131 45.5738 22.6581 45.6842C23.5993 46.3979 24.5979 46.4866 25.6765 46.0352C26.7552 45.5839 27.6053 44.7724 28.5557 44.1211Z",
    fill: "url(#paint20_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5445 17.5039C43.0579 18.1054 42.9213 19.3244 43.2738 19.8853C43.472 19.2105 44.2066 18.172 44.6603 17.951C44.2639 18.5188 43.9856 19.1161 43.7115 19.7479C44.0429 19.6686 44.344 19.612 44.6392 19.5252C45.7144 19.2071 46.3748 18.507 46.5578 17.3867C46.6953 16.5431 46.6911 16.5481 45.8325 16.5431C44.9293 16.5363 44.134 16.7751 43.5445 17.5039Z",
    fill: "url(#paint21_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9292 36.1783C18.6584 35.8552 18.4645 35.4823 18.2359 35.1306C18.0716 34.8737 17.8579 34.652 17.6073 34.4782C17.3568 34.3045 17.0742 34.1821 16.7761 34.1183C16.2586 34.0017 15.7238 33.9842 15.1998 34.0668C14.8439 34.1183 14.8423 34.1149 14.9468 34.47C14.9907 34.6236 15.0354 34.7771 15.0877 34.9281C15.5321 36.2129 16.733 37.0016 18.4046 36.6997C17.8845 36.4598 17.4541 36.0607 17.1758 35.56C18.6441 36.606 19.2732 36.9274 19.926 36.9207C19.5355 36.7123 19.1939 36.4963 18.9292 36.1783Z",
    fill: "url(#paint22_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5063 35.3068C40.4743 34.9543 40.4339 34.5984 40.2686 34.2695C40.2527 34.4665 40.2231 34.662 40.18 34.8548C39.9658 35.764 39.4016 36.3779 38.5945 36.814C37.9578 37.1572 37.4247 37.6193 37.1692 38.332C36.9795 38.859 37.1397 39.2487 37.6372 39.5017C37.9082 39.6373 38.2187 39.6717 38.5127 39.5987C39.5331 39.3676 40.1412 38.7031 40.4035 37.7214C40.6151 36.9286 40.578 36.1148 40.5063 35.3068ZM39.3122 38.6803C38.9748 38.9274 38.6434 38.9147 38.3507 38.6752C38.0733 38.4475 37.9966 38.0562 38.1644 37.6961C38.3525 37.2921 38.6898 37.0888 39.1089 36.9902C39.3358 36.9371 39.5897 36.964 39.7836 36.7768C39.7456 36.9573 39.6681 37.1091 39.6613 37.2828C39.8224 37.2972 39.7963 37.1032 39.9388 37.0568C39.9768 37.7096 39.8595 38.2788 39.313 38.6786L39.3122 38.6803Z",
    fill: "url(#paint23_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7853 34.3406C24.5027 34.1187 24.2388 33.8741 23.9621 33.6446C23.6468 33.3831 23.3204 33.1385 22.9189 33.0162C22.3741 32.855 21.9162 33.055 21.7989 33.5046C21.6961 33.9002 21.9195 34.1533 22.1987 34.3684C23.1153 35.0697 24.2001 35.5175 25.3444 35.6667C25.681 35.7229 26.0255 35.7102 26.3571 35.6293C26.6886 35.5483 27.0002 35.401 27.2732 35.196C26.2847 35.2492 25.497 34.8965 24.7853 34.3406Z",
    fill: "url(#paint24_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1368 29.9492C34.6806 31.6055 33.7563 32.6968 32.0417 32.949C31.4058 33.0426 30.7767 33.0274 30.2639 32.5568C30.1384 32.4308 30.0196 32.2982 29.908 32.1596C29.5091 32.9355 29.8364 33.816 30.6477 34.1837C31.9127 34.7588 33.5615 34.1609 34.2235 32.8858C33.3506 33.5402 32.8353 33.7603 32.3892 33.6659C34.0447 33.0022 35.0659 31.867 35.1368 29.9492Z",
    fill: "url(#paint25_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6247 30.4883C18.9694 30.5229 18.2256 31.093 18.035 31.7061C17.8788 32.2181 17.9036 32.7683 18.1055 33.2641C18.3073 33.76 18.6737 34.1711 19.1431 34.4284C20.0219 34.9209 20.9892 35.2237 21.9262 35.5906C21.9321 35.5906 21.9465 35.5737 21.9751 35.5484C20.3981 34.6486 19.5885 33.2587 19.3607 31.4716C19.0234 31.7955 18.8024 32.1564 18.8058 32.6742C18.4676 31.9051 18.7291 31.2473 19.6247 30.4883Z",
    fill: "url(#paint26_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.5357 14.0051C38.6431 14.1266 38.7812 14.217 38.9355 14.2665C38.4295 13.6112 38.147 12.945 38.2381 12.1582C38.3437 12.6273 38.5255 13.076 38.7761 13.4864C38.7676 13.1491 38.8731 12.832 38.9447 12.5132C39.0393 12.1653 39.062 11.8017 39.0114 11.4447C38.8731 10.6503 38.3165 10.14 37.7818 9.61376C37.7354 9.56821 37.689 9.54464 37.6359 9.61376C37.1569 10.2328 36.7925 10.9016 36.9797 11.7128C37.2033 12.6684 37.8383 13.3624 38.5357 14.0051Z",
    fill: "url(#paint27_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2104 14.4575C41.3918 15.2376 41.2526 16.0861 41.7671 16.781C41.647 16.3528 41.6713 15.8969 41.8362 15.484C41.8986 15.3153 41.945 15.1415 41.9998 14.9703C42.225 14.2712 42.0555 13.6732 41.5393 13.163C41.4255 13.0508 41.3007 12.948 41.202 12.8256C41.0688 12.6679 40.9659 12.5111 41.1632 12.3037C41.3049 12.1543 41.2163 12.0236 41.0317 11.9781C40.9389 11.9549 40.8419 11.9552 40.7493 11.9789C40.6567 12.0026 40.5714 12.049 40.5012 12.1139C40.3208 12.2742 40.1908 12.4834 40.1267 12.7161C39.7337 13.9515 40.0854 15.0125 41.1557 16.0836C41.0562 15.544 41.0749 14.9892 41.2104 14.4575Z",
    fill: "url(#paint28_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.0338 24.5147C45.1458 24.341 44.2628 24.2557 43.363 24.3907C42.6461 24.4987 41.9579 24.6986 41.3322 25.0656C40.5746 25.5271 39.7657 25.8983 38.9219 26.1716C39.3705 26.0872 39.8175 26.1437 40.262 26.1345C41.4412 26.1156 42.6072 25.8833 43.7037 25.4486C44.4796 25.1407 45.2385 24.7906 46.0338 24.5147Z",
    fill: "url(#paint29_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8343 28.9102C34.5965 29.6694 34.2026 30.2599 33.6165 30.7104C32.6297 31.4696 31.557 31.1229 31.2071 29.9106C30.5585 30.5273 30.6488 31.4739 31.3807 31.9952C32.0799 32.4937 33.1822 32.3832 33.8687 31.7421C34.077 31.5605 34.2416 31.3341 34.3502 31.0799C34.136 31.1955 33.9606 31.3608 33.6544 31.4173C34.4557 30.7526 35.0291 30.0389 34.8343 28.9102Z",
    fill: "url(#paint30_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4901 41.2268C22.4224 41.4748 21.3632 41.7919 20.2449 41.6291C20.1057 41.6089 20.0543 41.689 19.9986 41.7937C19.7929 42.1766 19.458 42.3588 19.0338 42.4111C18.6408 42.4592 18.3026 42.3226 17.9375 42.0796C18.0513 42.4424 18.2748 42.6136 18.5278 42.7545C19.7321 43.4293 21.3547 43.2606 22.3803 42.3251C22.7859 41.9564 23.1747 41.5709 23.5989 41.2031C23.5652 41.2124 23.5272 41.2183 23.4901 41.2268Z",
    fill: "url(#paint31_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9045 33.8285C36.3606 34.5302 35.9634 35.2875 35.9769 36.2059C35.9845 36.9228 36.4559 37.2905 37.15 37.1151C37.9469 36.9118 38.5339 36.1536 38.5617 35.2808C38.5744 34.8903 38.5491 34.5049 38.3577 34.149C38.3577 34.5462 38.3365 34.9316 38.151 35.29C37.8921 35.7884 37.4181 36.0044 37.026 35.8011C36.6339 35.5979 36.5368 35.1222 36.773 34.6162C36.9164 34.3168 37.1238 34.0588 37.3169 33.7923C37.5927 33.4243 37.717 32.9646 37.6644 32.5078C37.5034 33.0079 37.2166 33.4262 36.9045 33.8285Z",
    fill: "url(#paint32_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6852 36.6581C23.1193 36.7078 22.5526 36.7753 22.0196 36.9955C21.7303 37.1144 21.4562 37.2553 21.2867 37.5363C21.1172 37.8172 21.1661 38.1562 21.3929 38.3199C21.6198 38.4836 21.8147 38.449 22.0676 38.1622C22.3445 37.8586 22.7005 37.6383 23.0957 37.5261C23.5506 37.3847 24.0235 37.3091 24.4999 37.3017C24.2823 37.4561 24.0664 37.6113 23.8463 37.7631C23.6933 37.8566 23.5535 37.9701 23.4305 38.1006C23.3741 38.1583 23.3371 38.2321 23.3247 38.3118C23.3123 38.3915 23.3252 38.4731 23.3613 38.5452C23.3855 38.6009 23.4262 38.648 23.4779 38.6799C23.5296 38.7119 23.5899 38.7273 23.6506 38.724C23.7315 38.725 23.8106 38.7001 23.8764 38.6529C23.942 38.6057 23.9909 38.5387 24.0158 38.4617C24.0357 38.4157 24.0502 38.3676 24.0588 38.3182C24.1204 37.7699 24.4805 37.4316 24.9022 37.1372C25.2032 36.9263 25.517 36.7314 25.8762 36.4961C25.0986 36.556 24.3911 36.5965 23.6852 36.6581Z",
    fill: "url(#paint33_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.786 14.7402C32.6038 15.162 32.8576 15.5484 33.3131 15.5357C33.4327 15.5316 33.5515 15.5143 33.6673 15.4842C34.2734 15.3412 34.8301 15.0386 35.2798 14.6077C35.6854 14.2163 36.1552 13.9556 36.748 13.9472C36.5726 13.7945 36.5735 13.7928 36.4107 13.7447C35.3658 13.4343 34.3757 13.6106 33.4261 14.0948C33.1425 14.2266 32.9154 14.4555 32.786 14.7402Z",
    fill: "url(#paint34_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9833 21.3458C37.4602 21.528 37.9684 21.614 38.4786 21.5988C38.9577 21.5887 39.4355 21.5814 39.9123 21.5769C40.5482 21.5701 41.1394 21.7144 41.7104 22.1868C41.6093 21.9768 41.4761 21.7838 41.3157 21.6148C40.7253 21.0294 39.9865 20.7991 39.1929 20.6869C38.1034 20.5257 37.0061 20.5704 35.8457 20.5469C36.2041 20.9163 36.5566 21.1804 36.9833 21.3458Z",
    fill: "url(#paint35_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8074 41.6717C31.671 41.6735 31.5375 41.6329 31.4253 41.5555C31.313 41.4782 31.2276 41.3678 31.1808 41.2397C31.0635 40.9352 30.9134 40.9023 30.6629 41.1301C30.3652 41.3949 30.3694 41.9003 30.6806 42.2664C31.0483 42.6983 31.5316 42.846 32.0781 42.7852C33.0378 42.6772 33.6973 42.0589 34.3323 41.4161C34.6252 41.1387 34.8602 40.8062 35.0239 40.4375C34.9851 40.4543 34.9657 40.4561 34.9582 40.4662C34.1578 41.5274 33.0227 41.7189 31.8074 41.6717Z",
    fill: "url(#paint36_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3163 32.6559C24.8105 33.5372 25.3949 34.3341 26.3749 34.7533C25.8553 34.3173 25.6158 33.7328 25.5239 33.0859C25.4691 32.7124 25.4565 32.332 25.4244 31.9542C25.3957 31.6168 25.314 31.3014 25.0946 31.04C24.9016 30.8097 24.6502 30.7027 24.3474 30.7945C24.0809 30.8789 23.9258 31.1218 23.9258 31.4464C23.9281 31.5759 23.9439 31.7049 23.973 31.8311C24.045 32.1218 24.1608 32.3999 24.3163 32.6559Z",
    fill: "url(#paint37_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7832 28.4924C16.2463 28.8743 16.6701 29.3014 17.0482 29.7675C17.3134 30.0979 17.626 30.3872 17.976 30.6261C17.8283 30.3831 17.6757 30.1512 17.5449 29.9041C17.1975 29.2471 16.9917 28.5387 16.786 27.8303C16.7152 27.5593 16.5881 27.3061 16.4132 27.0873C16.1349 26.7568 15.677 26.6657 15.3674 26.8706C15.0714 27.068 15.0115 27.5065 15.2342 27.8961C15.3782 28.1275 15.5645 28.3298 15.7832 28.4924Z",
    fill: "url(#paint38_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1073 34.7177C29.3907 34.6865 29.6733 34.6443 30.0047 34.6005C29.3494 34.2175 28.9876 33.6725 28.867 32.9875C28.8164 32.6956 28.8476 32.3894 28.813 32.0933C28.765 31.6783 28.6022 31.4868 28.3298 31.4699C28.0346 31.4514 27.7867 31.6538 27.7394 32.0604C27.6264 33.0306 27.9384 33.8673 28.6435 34.5473C28.7032 34.6085 28.7758 34.6555 28.8561 34.6851C28.9364 34.7145 29.0222 34.7257 29.1073 34.7177Z",
    fill: "url(#paint39_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6098 31.5355C21.6815 31.0649 21.4336 30.6491 21.0431 30.5859C20.5809 30.5099 20.1761 30.811 20.1466 31.328C20.0707 32.5031 20.4341 33.6644 21.1662 34.5867C20.8289 33.8673 20.8912 33.1699 21.2395 32.4784C21.3922 32.1756 21.5575 31.8779 21.6098 31.5355Z",
    fill: "url(#paint40_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1952 22.3086C40.399 22.0648 39.5852 22.0766 38.7689 22.1576C38.5296 22.1756 38.2981 22.2512 38.0942 22.3777C37.9645 22.4553 37.8654 22.575 37.8135 22.717C37.7616 22.8589 37.7601 23.0144 37.8091 23.1573C37.8608 23.294 37.9587 23.4082 38.0857 23.4804C38.2128 23.5525 38.3611 23.5778 38.5049 23.552C38.6419 23.5287 38.7757 23.4896 38.9038 23.4356C39.3786 23.2517 39.8222 23.002 40.2801 22.781C40.6858 22.5861 41.1058 22.4326 41.6346 22.5609C41.5169 22.4343 41.3637 22.3464 41.1952 22.3086Z",
    fill: "url(#paint41_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0776 30.5826C15.2175 30.5784 15.3567 30.5632 15.4992 30.5488C15.9373 30.5007 16.3805 30.527 16.8098 30.6265C17.2053 30.721 17.5983 30.8272 17.9905 30.9285L18.0167 30.8812C17.4887 30.4924 16.9709 30.0891 16.4294 29.7196C15.9943 29.4227 15.5068 29.2236 14.9654 29.2902C14.4923 29.3484 14.2562 29.6218 14.2857 30.0115C14.3152 30.4012 14.5792 30.5978 15.0776 30.5826Z",
    fill: "url(#paint42_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9977 36.2377C22.3033 35.8488 20.4944 35.869 18.9688 34.8398C19.0074 35.004 19.0684 35.1622 19.15 35.3097C19.4874 35.8724 19.8652 36.4064 20.6124 36.3837C21.7383 36.3566 22.8684 36.4165 23.9977 36.2377Z",
    fill: "url(#paint43_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1452 37.6134C16.9294 37.8665 16.91 38.1735 17.0837 38.4131C17.2389 38.6274 17.5054 38.6906 17.8132 38.5818C17.8792 38.5574 17.9436 38.5293 18.0063 38.4975C18.6759 38.1659 19.2081 37.6209 19.8819 37.2844C19.3177 37.1579 18.7704 37.0254 18.2062 37.1157C17.8073 37.1806 17.4227 37.2903 17.1452 37.6134Z",
    fill: "url(#paint44_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3799 28.1054C18.4988 27.8084 18.6185 27.5148 18.5975 27.1842C18.5696 26.7514 18.3141 26.4587 17.9565 26.457C17.5989 26.4553 17.2886 26.7396 17.297 27.1631C17.3164 28.075 17.5593 28.9262 18.1252 29.6719C18.0021 29.1143 18.1783 28.6064 18.3799 28.1054Z",
    fill: "url(#paint45_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3226 34.7536C27.5636 34.3107 27.1815 33.684 26.991 32.9332C26.8982 32.5662 26.8518 32.1882 26.7691 31.8179C26.7405 31.6888 26.8164 31.4805 26.6646 31.4459C26.4867 31.4096 26.3821 31.602 26.2876 31.742C26.2101 31.859 26.1596 31.9919 26.14 32.1309C26.0127 32.9534 26.2151 33.684 26.8012 34.2769C27.1917 34.6718 27.6901 34.8152 28.3226 34.7536Z",
    fill: "url(#paint46_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7373 30.7975C47.1546 30.5377 46.5423 30.5571 45.8516 30.5874C46.4369 31.032 46.8265 31.5787 47.3316 32.0106C47.4575 32.1252 47.6082 32.209 47.7719 32.2553C48.0122 32.316 48.2341 32.2848 48.4027 32.0924C48.5714 31.9001 48.5528 31.6707 48.4508 31.4471C48.3049 31.1308 48.0468 30.9358 47.7373 30.7975Z",
    fill: "url(#paint47_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1935 22.9987C40.9185 22.9144 40.7102 23.0443 40.5381 23.2518C40.3172 23.515 40.2481 23.8423 40.1848 24.1629C40.0709 24.7424 39.8744 25.2781 39.4258 25.6999C40.0794 25.4393 40.7034 25.1381 41.1547 24.5745C41.3857 24.286 41.5367 23.9672 41.5148 23.5859C41.4971 23.3387 41.4752 23.0881 41.1935 22.9987Z",
    fill: "url(#paint48_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3649 29.4456C20.6448 29.1503 20.6558 28.7707 20.4298 28.5235C20.2038 28.2764 19.8394 28.2704 19.5072 28.5235C18.8232 29.0373 18.8561 29.7628 18.9109 30.5794C19.4026 30.1382 19.9525 29.8809 20.3649 29.4456Z",
    fill: "url(#paint49_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3697 38.7188C42.4103 39.3539 42.1648 39.9116 41.9481 40.4776C41.8368 40.7678 41.7575 41.0681 41.8132 41.3836C41.8713 41.7152 42.0712 41.9219 42.3487 41.9362C42.6396 41.9505 42.8471 41.7835 42.955 41.4621C43.0057 41.3097 43.0187 41.1473 42.993 40.9889C42.8724 40.211 42.557 39.4855 42.3697 38.7188Z",
    fill: "url(#paint50_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4108 31.0598C16.0827 31.0944 15.7775 31.1855 15.5953 31.49C15.5254 31.5954 15.4895 31.7196 15.4923 31.846C15.4952 31.9724 15.5368 32.0949 15.6113 32.197C15.7648 32.4171 15.9807 32.4837 16.2447 32.3952C16.8941 32.1758 17.341 31.6554 17.9078 31.3078C17.4026 31.1231 16.9185 31.0066 16.4108 31.0598Z",
    fill: "url(#paint51_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9076 40.0679C37.4589 40.0367 37.2329 39.8723 37.0937 39.4336C36.672 39.8469 36.597 40.2712 36.8601 40.6542C37.1055 41.0119 37.5348 41.1072 38.0096 40.9022C38.6101 40.6441 39.057 40.2105 39.4079 39.6639C38.9423 39.9372 38.454 40.1059 37.9076 40.0679Z",
    fill: "url(#paint52_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3349 14.7273C44.4901 14.524 44.5399 14.2869 44.378 14.0609C44.2253 13.8482 44.0085 13.8145 43.7632 13.8846C43.4258 13.9799 43.2074 14.222 43.0041 14.4801C42.7098 14.8504 42.5555 15.3009 42.3008 15.7067C42.6524 15.5034 43.0598 15.473 43.43 15.3347C43.7766 15.2039 44.1039 15.0301 44.3349 14.7273Z",
    fill: "url(#paint53_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6969 38.0949C44.8606 38.0684 45.0084 37.9816 45.1114 37.8516C45.2144 37.7216 45.2651 37.5578 45.2535 37.3923C45.2355 37.1516 45.1295 36.9261 44.9558 36.7587C44.7422 36.5483 44.505 36.3631 44.249 36.207C44.1748 36.4086 44.1073 36.5832 44.0466 36.7595C43.949 37.0106 43.9199 37.2832 43.9623 37.5492C43.9913 37.717 44.0838 37.8673 44.2205 37.9689C44.3572 38.0705 44.5278 38.1156 44.6969 38.0949Z",
    fill: "url(#paint54_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0216 46.3957C26.9727 46.5897 26.9913 46.7559 27.1599 46.874C27.3286 46.9921 27.5015 46.9584 27.6659 46.8504C27.9113 46.6867 28.0286 46.4353 28.1248 46.1696C28.306 45.6634 28.4081 45.1362 28.6308 44.625C28.2504 44.9751 27.8624 45.3176 27.493 45.6786C27.2813 45.8794 27.095 46.1005 27.0216 46.3957Z",
    fill: "url(#paint55_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0983 24.1189C47.5902 24.2668 47.0734 24.3826 46.5508 24.4656C46.9394 24.5884 47.3192 24.7374 47.6876 24.9118C47.9296 25.0274 48.1818 25.132 48.4593 25.1126C48.5996 25.103 48.731 25.0402 48.8268 24.9371C48.9225 24.8339 48.9753 24.6983 48.9745 24.5575C48.9644 24.2968 48.7486 24.0961 48.4542 24.0877C48.3347 24.0815 48.2149 24.0919 48.0983 24.1189Z",
    fill: "url(#paint56_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0876 19.6652C38.0076 19.7094 37.9467 19.7818 37.9168 19.8682C37.887 19.9546 37.89 20.0491 37.9256 20.1334C37.9973 20.3139 38.1644 20.2329 38.2925 20.2076C38.5961 20.1494 38.8963 20.0887 39.2084 20.1148C39.7988 20.1638 40.2879 20.432 40.7795 20.7374C40.3191 20.1325 39.8004 19.596 38.9992 19.4669C38.6812 19.4128 38.3545 19.4839 38.0876 19.6652Z",
    fill: "url(#paint57_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3318 16.6862C43.4364 16.402 43.3318 16.1294 43.1075 16.0552C42.8672 15.975 42.6352 16.0991 42.5171 16.3825C42.2271 17.092 42.4961 17.7609 42.6605 18.4384C42.6884 17.9929 42.8866 17.6116 43.0763 17.2278C43.1712 17.052 43.2565 16.8712 43.3318 16.6862Z",
    fill: "url(#paint58_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0209 17.4299C38.8328 17.3532 38.6524 17.3397 38.4972 17.5025C38.4188 17.5736 38.3665 17.6688 38.3486 17.7732C38.3307 17.8774 38.3483 17.9847 38.3985 18.0778C38.5133 18.3022 38.7048 18.478 38.9382 18.573C39.1812 18.6844 39.429 18.7865 39.7133 18.9105C39.6849 18.5854 39.6203 18.2646 39.521 17.9538C39.4817 17.8348 39.4165 17.7261 39.33 17.6355C39.2435 17.5448 39.1379 17.4746 39.0209 17.4299Z",
    fill: "url(#paint59_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0345 34.8081C36.9384 35.0265 36.8995 35.2543 37.1534 35.4129C37.2622 35.4763 37.391 35.4963 37.514 35.4688C37.6369 35.4413 37.7449 35.3682 37.8163 35.2644C37.9682 35.0626 38.037 34.8102 38.0085 34.5592C37.9815 34.2217 37.9411 33.8843 37.9057 33.5469C37.7277 33.8511 37.5237 34.1393 37.2959 34.4082C37.1918 34.5296 37.104 34.664 37.0345 34.8081Z",
    fill: "url(#paint60_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4009 10.3996C35.5427 11.3799 35.9913 12.1855 36.8634 12.7204C36.7225 12.5516 36.5766 12.3879 36.4417 12.2142C35.8589 11.4617 35.7063 10.6544 36.1541 9.78212C36.2485 9.59649 36.1229 9.59993 36.0158 9.59148C35.6261 9.56275 35.331 9.91623 35.4009 10.3996Z",
    fill: "url(#paint61_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9345 40.8906C18.582 40.8906 18.3011 41.1294 18.2969 41.4305C18.2927 41.7317 18.6115 42.0101 18.9472 42.0135C19.2634 42.0135 19.6058 41.7376 19.6049 41.4787C19.6033 41.1581 19.298 40.8906 18.9345 40.8906Z",
    fill: "url(#paint62_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4024 36.7547C15.1772 36.6703 14.9596 36.6863 14.812 36.8981C14.7513 36.9849 14.7194 37.0886 14.7207 37.1946C14.7221 37.3005 14.7567 37.4033 14.8196 37.4886C14.9638 37.7037 15.1965 37.7273 15.41 37.6438C15.8493 37.4751 16.2373 37.1866 16.7011 37.0356C16.2339 37.0676 15.8173 36.9183 15.4024 36.7547Z",
    fill: "url(#paint63_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3548 43.9568C19.9728 43.8936 19.7037 44.1584 19.7644 44.5338C19.8336 44.9362 20.2704 45.0779 20.6634 44.8114C21.0134 44.5726 21.2395 44.2149 21.5363 43.875C21.0194 44.069 21.0194 44.069 20.3548 43.9568Z",
    fill: "url(#paint64_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9202 20.3319C34.0486 20.3541 34.1808 20.3364 34.2989 20.2813C34.6581 20.1202 34.9921 19.9059 35.3725 19.7642C34.9891 19.7695 34.6111 19.674 34.2761 19.4875C34.1953 19.4491 34.1075 19.4275 34.018 19.4242C33.9028 19.4123 33.7874 19.4459 33.6966 19.518C33.6059 19.5901 33.5468 19.6947 33.5323 19.8097C33.5188 19.9298 33.5513 20.0504 33.6233 20.1474C33.6953 20.2443 33.8015 20.3103 33.9202 20.3319Z",
    fill: "url(#paint65_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1509 17.8383C35.9561 18.0382 35.9595 18.3107 36.1653 18.53C36.3339 18.7089 36.5473 18.7679 36.8197 18.7671C36.904 18.7232 37.1183 18.8363 37.1284 18.5984C37.1402 18.3141 37.0837 18.0408 36.8694 17.8332C36.8231 17.7843 36.7672 17.7454 36.7052 17.719C36.6432 17.6926 36.5764 17.6792 36.509 17.6797C36.4417 17.6802 36.3751 17.6945 36.3135 17.7218C36.2519 17.7491 36.1966 17.7887 36.1509 17.8383Z",
    fill: "url(#paint66_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.548 37.7499C20.7335 37.3914 21.0473 37.1595 21.3813 36.9536C21.6966 36.7562 22.045 36.6373 22.3933 36.4922C20.6425 36.5276 19.8143 37.5197 20.0268 38.2544C20.128 37.9853 20.4291 37.9794 20.548 37.7499Z",
    fill: "url(#paint67_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7792 26.7918C46.7901 26.521 46.5194 26.2704 46.2065 26.262C45.8692 26.2527 45.6373 26.4484 45.6272 26.7606C45.6187 27.033 45.8801 27.2667 46.2006 27.2853C46.4688 27.2979 46.7699 27.0415 46.7792 26.7918Z",
    fill: "url(#paint68_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3594 19.1055C41.3703 20.3641 41.9936 21.3334 42.5662 22.3499C42.4946 21.1385 41.8586 20.1743 41.3594 19.1055Z",
    fill: "url(#paint69_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8458 36.9665C28.8408 37.2406 29.1266 37.5182 29.4117 37.5148C29.711 37.5148 29.9961 37.2499 29.9944 36.9808C29.9927 36.7117 29.7069 36.4747 29.3889 36.4806C29.0895 36.4848 28.8542 36.6991 28.8458 36.9665Z",
    fill: "url(#paint70_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.406 20.9085C41.1184 19.7891 41.0627 18.5903 40.248 17.5586C40.6622 18.7295 40.7339 19.9207 41.406 20.9085Z",
    fill: "url(#paint71_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.773 41.9254C27.722 41.9559 27.6738 41.9906 27.6288 42.0292C27.4289 42.203 27.3462 42.4105 27.4652 42.6653C27.4835 42.7121 27.5109 42.7547 27.5458 42.7909C27.5807 42.827 27.6224 42.8559 27.6685 42.8758C27.7146 42.8957 27.7641 42.9063 27.8144 42.9069C27.8646 42.9076 27.9145 42.8983 27.961 42.8796C28.2141 42.8019 28.3355 42.602 28.3406 42.3261C28.3296 42.2671 28.322 42.1979 28.3052 42.1313C28.2174 41.7913 28.0758 41.7331 27.773 41.9254Z",
    fill: "url(#paint72_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1348 39.9269C33.1382 40.0418 33.1848 40.1511 33.2654 40.2331C33.3459 40.315 33.4543 40.3635 33.5691 40.369C33.6989 40.3645 33.8223 40.3122 33.9158 40.222C34.0093 40.1318 34.066 40.0101 34.0751 39.8806C34.0801 39.6351 33.9064 39.4647 33.6365 39.4538C33.5722 39.4505 33.5078 39.4602 33.4473 39.4824C33.3869 39.5047 33.3315 39.5389 33.2846 39.5831C33.2377 39.6274 33.2002 39.6806 33.1745 39.7397C33.1487 39.7988 33.1352 39.8625 33.1348 39.9269Z",
    fill: "url(#paint73_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6875 9.36238C24.9186 9.3573 25.1699 9.09996 25.1648 8.87393C25.1597 8.66724 24.9253 8.47324 24.6825 8.47661C24.6243 8.47689 24.5668 8.48871 24.5132 8.51128C24.4596 8.53385 24.4109 8.56673 24.3701 8.60807C24.3292 8.64948 24.2968 8.69848 24.2749 8.75236C24.253 8.80616 24.2418 8.86383 24.2422 8.922C24.2426 8.98018 24.2543 9.0377 24.2769 9.09129C24.2994 9.14488 24.3323 9.19353 24.3737 9.23443C24.415 9.27534 24.464 9.30765 24.5179 9.32957C24.5717 9.35157 24.6293 9.36267 24.6875 9.36238Z",
    fill: "url(#paint74_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4183 9.3434C35.5428 9.33523 35.6597 9.28057 35.746 9.1903C35.8321 9.10003 35.8813 8.98068 35.8838 8.8558C35.8828 8.79878 35.8705 8.74254 35.8475 8.69031C35.8246 8.63808 35.7914 8.59094 35.75 8.55168C35.7086 8.51242 35.6599 8.48176 35.6065 8.46156C35.5532 8.44136 35.4964 8.43204 35.4394 8.43405C35.3823 8.4314 35.3255 8.44035 35.272 8.46041C35.2186 8.4804 35.1698 8.51106 35.1286 8.55054C35.0873 8.58994 35.0545 8.63737 35.0321 8.68981C35.0098 8.74232 34.9982 8.79878 34.9983 8.8558C34.9899 9.11479 35.1889 9.34598 35.4183 9.3434Z",
    fill: "url(#paint75_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8301 10.4096C26.8301 10.618 27.0636 10.8382 27.2855 10.8382C27.5073 10.8382 27.7392 10.6197 27.7493 10.4164C27.7513 10.3566 27.741 10.297 27.719 10.2413C27.6971 10.1857 27.6639 10.1351 27.6216 10.0928C27.5793 10.0505 27.5287 10.0173 27.4731 9.99532C27.4174 9.9734 27.3579 9.96308 27.2981 9.96509C27.1789 9.96803 27.0651 10.0152 26.9786 10.0973C26.8921 10.1794 26.8392 10.2907 26.8301 10.4096Z",
    fill: "url(#paint76_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.506 12.0195C27.1957 12.0195 27.0405 12.1545 27.0371 12.4279C27.0379 12.4871 27.0504 12.5456 27.0738 12.6C27.0973 12.6543 27.1313 12.7035 27.1738 12.7447C27.2164 12.7859 27.2667 12.8182 27.3219 12.8398C27.377 12.8615 27.4358 12.872 27.4951 12.8707C27.615 12.8663 27.7284 12.8153 27.8113 12.7285C27.8941 12.6417 27.9398 12.526 27.9386 12.4059C27.9319 12.1807 27.754 12.0195 27.506 12.0195Z",
    fill: "url(#paint77_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1465 11.3841C27.1465 11.6684 27.3 11.8058 27.5993 11.8058C27.6558 11.8087 27.7122 11.7997 27.765 11.7797C27.8178 11.7596 27.8659 11.7287 27.9062 11.6891C27.9464 11.6494 27.978 11.6018 27.999 11.5494C28.0199 11.4968 28.0297 11.4405 28.0278 11.3841C28.0228 11.2641 27.9722 11.1507 27.8863 11.0668C27.8003 10.9831 27.6856 10.9354 27.5656 10.9336C27.4527 10.9441 27.3475 10.9959 27.2702 11.0789C27.1929 11.162 27.1488 11.2706 27.1465 11.3841Z",
    fill: "url(#paint78_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5872 10.0712C26.7068 10.0661 26.8204 10.0166 26.9054 9.93239C26.9906 9.84822 27.0413 9.73524 27.0477 9.61567C27.0477 9.36764 26.8681 9.20065 26.6024 9.20315C26.5432 9.20373 26.4847 9.2159 26.4302 9.23912C26.3757 9.26233 26.3263 9.29607 26.2849 9.33834C26.2434 9.38068 26.2108 9.43076 26.1887 9.48571C26.1667 9.54066 26.1556 9.59947 26.1563 9.65865C26.1682 9.76719 26.2179 9.86799 26.2967 9.94343C26.3755 10.0189 26.4784 10.0641 26.5872 10.0712Z",
    fill: "url(#paint79_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1553 9.12259C26.1529 9.22439 26.1153 9.32211 26.049 9.39934C25.9984 9.4621 25.9332 9.51161 25.8593 9.54356C25.8061 9.56691 25.7486 9.57866 25.6906 9.57816C25.5943 9.57444 25.5018 9.53912 25.4275 9.47779C25.409 9.46282 25.3916 9.44677 25.3752 9.42972L25.3541 9.40694V9.40271L25.3364 9.37993L25.3195 9.35464C25.3144 9.34704 25.3102 9.33945 25.306 9.33186C25.3003 9.32254 25.2954 9.31258 25.2917 9.30227C25.2707 9.26007 25.2591 9.21365 25.2579 9.16651C25.2557 9.07022 25.2854 8.97594 25.3423 8.89821C25.3831 8.84226 25.4362 8.79633 25.4974 8.76388C25.5586 8.73143 25.6264 8.7133 25.6956 8.71094H25.7091C25.931 8.71094 26.0937 8.82485 26.1401 9.00875C26.1503 9.04579 26.1554 9.08412 26.1553 9.12259Z",
    fill: "url(#paint80_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3097 20.288C44.3611 20.2543 44.4572 20.2365 44.4336 20.1463C44.41 20.056 44.3231 20.067 44.2582 20.0619C43.9766 20.0307 43.7311 20.0966 43.5456 20.3319C43.344 20.5849 43.3996 20.8726 43.4478 21.1679C43.6392 20.7714 43.9605 20.5167 44.3097 20.288Z",
    fill: "url(#paint81_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7704 32.852C16.541 32.8629 16.4288 32.9945 16.4238 33.2164C16.4239 33.2661 16.4339 33.3154 16.4533 33.3612C16.4727 33.407 16.5012 33.4485 16.5368 33.4831C16.5725 33.5178 16.6148 33.545 16.6611 33.5631C16.7075 33.5811 16.7569 33.5897 16.8067 33.5884C16.9069 33.5812 17.0008 33.5365 17.0696 33.4631C17.1383 33.3899 17.177 33.2933 17.1778 33.1928C17.1778 32.9937 16.9989 32.8427 16.7704 32.852Z",
    fill: "url(#paint82_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9212 46.6445C25.8712 46.6441 25.8218 46.6544 25.7761 46.6748C25.7304 46.6951 25.6896 46.7249 25.6565 46.7623C25.6234 46.7998 25.5986 46.8439 25.5838 46.8916C25.5691 46.9394 25.5648 46.9898 25.5712 47.0394C25.5721 47.0871 25.583 47.1342 25.6035 47.1775C25.6239 47.2207 25.6532 47.2591 25.6896 47.2901C25.7259 47.3211 25.7685 47.3441 25.8144 47.3575C25.8603 47.3708 25.9085 47.3742 25.9558 47.3675C26.1869 47.3574 26.2754 47.1988 26.2932 46.9887C26.2644 46.7703 26.1481 46.6454 25.9212 46.6445Z",
    fill: "url(#paint83_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6621 23.2512C41.6824 23.4554 41.7667 23.5887 41.9724 23.6013C42.0225 23.605 42.0727 23.598 42.1198 23.5807C42.1669 23.5634 42.2098 23.5364 42.2456 23.5013C42.2814 23.4662 42.3094 23.4238 42.3275 23.3771C42.3457 23.3303 42.3538 23.2802 42.3511 23.2302C42.3419 23.0024 42.2112 22.8725 41.991 22.875C41.7524 22.8784 41.69 23.0673 41.6621 23.2512Z",
    fill: "url(#paint84_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7207 13.1173C34.1289 13.4918 34.1289 13.4918 35.2691 13.2775C34.769 13.1518 34.2765 12.9072 33.7207 13.1173Z",
    fill: "url(#paint85_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.366 30.1984C39.5725 30.0945 39.4831 29.9048 39.3963 29.7605C39.2605 29.5361 39.0328 29.4003 38.7891 29.1641C38.8734 29.4914 38.9164 29.7352 38.9898 29.9705C39.0446 30.1435 39.1677 30.2979 39.366 30.1984Z",
    fill: "url(#paint86_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6588 38.3327C24.4497 38.321 24.3434 38.456 24.3392 38.6483C24.3352 38.6912 24.3404 38.7344 24.3544 38.7751C24.3684 38.8158 24.391 38.8531 24.4205 38.8845C24.45 38.9158 24.4858 38.9406 24.5256 38.957C24.5654 38.9734 24.6082 38.9812 24.6512 38.9798C24.8427 38.9798 24.9582 38.8558 24.9886 38.6491C24.9859 38.5637 24.9499 38.4828 24.8882 38.4236C24.8266 38.3645 24.7442 38.3319 24.6588 38.3327Z",
    fill: "url(#paint87_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7732 25.7905C26.8491 25.7129 26.8061 25.5029 26.9765 25.556C27.0887 25.5906 27.0869 25.7568 27.1367 25.8631C27.2868 26.1861 27.5187 26.4291 27.8822 26.4215C28.2331 26.4147 28.5443 26.2688 28.6649 25.8875C28.7155 25.7298 28.7813 25.7981 28.8521 25.8706C28.9492 25.9842 29.0558 26.0892 29.1709 26.1845C29.418 26.3591 29.6929 26.3937 29.9602 26.2368C30.177 26.1103 30.2259 25.9095 30.0766 25.6556C30.4536 25.7736 30.7741 25.896 31.1224 25.8496C31.2477 25.8402 31.3675 25.7942 31.4666 25.717C31.5658 25.6399 31.64 25.5351 31.6799 25.416C31.7693 25.168 31.5837 25.0532 31.4429 24.9166C31.4112 24.8923 31.377 24.8716 31.3408 24.855C31.3543 24.8314 31.3678 24.8077 31.3822 24.7841L31.6267 24.8735C31.7698 24.9159 31.9222 24.9143 32.0643 24.8692C32.2066 24.8241 32.332 24.7375 32.4245 24.6205C32.5038 24.5074 32.5257 24.3859 32.4194 24.2965C32.1842 24.0966 31.8857 24.0435 31.5947 23.9684C31.3796 23.9152 31.4707 24.1624 31.3526 24.2062C31.2896 24.2355 31.229 24.2696 31.1713 24.3083C31.1347 24.3237 31.1018 24.3467 31.0747 24.3757C31.0476 24.4048 31.0271 24.4394 31.0144 24.477C30.8205 25.1056 30.2967 25.3923 29.6811 25.1941C29.5318 25.1452 29.4618 25.1814 29.3657 25.2928C29.2642 25.4169 29.1318 25.5121 28.9818 25.5686C28.8318 25.6252 28.6696 25.6412 28.5114 25.6151C28.1032 25.5653 27.8308 25.3392 27.6073 25.0245C26.9099 25.6538 26.2132 25.4464 25.558 24.4037C25.5023 24.8457 25.4424 25.2692 25.7047 25.6538C25.9552 26.02 26.4941 26.0765 26.7732 25.7905Z",
    fill: "url(#paint88_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.567 24.2587C28.2786 24.1685 28.0677 24.3304 27.8291 24.4106C27.738 24.4409 27.7641 24.5202 27.7785 24.5886C27.8628 24.9909 28.26 25.3073 28.6412 25.2778C29.0629 25.2457 29.2754 24.996 29.299 24.4865C29.3665 24.5582 29.4264 24.624 29.488 24.6881C29.6106 24.8214 29.7786 24.9039 29.959 24.9195C30.1394 24.9351 30.3191 24.8827 30.4629 24.7724C30.7833 24.5489 30.6543 24.3051 30.4738 24.0554C30.7201 24.0225 30.9866 24.2072 31.1485 23.9111C31.2893 23.6505 31.0726 23.5214 30.8778 23.302C31.0465 23.3746 31.1401 23.4041 31.2227 23.4514C31.399 23.5509 31.5078 23.47 31.5862 23.3198C31.711 23.0785 31.5694 22.9301 31.3746 22.8457C31.1966 22.7681 30.9739 22.6416 30.8331 22.9039C30.7797 23.0325 30.6855 23.1398 30.5649 23.2093C30.5379 23.2218 30.5157 23.2427 30.5014 23.2688C30.4872 23.2949 30.4816 23.3249 30.4857 23.3544C30.5008 23.7509 30.3726 23.8749 29.9678 23.8606C29.8717 23.8606 29.7992 23.8428 29.7148 23.9398C29.5792 24.1042 29.3964 24.2229 29.1911 24.28C28.9858 24.337 28.768 24.3296 28.567 24.2587Z",
    fill: "url(#paint89_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1914 22.7891C28.1914 22.7891 28.1914 22.7934 28.1914 22.7959H28.1999L28.1914 22.7891Z",
    fill: "url(#paint90_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7988 23.9973C25.8608 24.2009 25.9588 24.3918 26.0881 24.5608C26.3799 24.9387 26.7434 25.0509 27.1414 24.8982C27.2916 24.8417 27.413 24.759 27.4332 24.5911C27.4569 24.3913 27.2646 24.436 27.1667 24.3726C27.1356 24.3533 27.101 24.3398 27.0462 24.3127C27.6525 24.236 27.6525 24.236 28.2066 23.8159C28.5068 23.5889 28.5439 23.2819 28.3112 22.9884C28.264 22.9301 28.1914 22.8854 28.1914 22.7969H27.2815C27.5218 22.9791 27.806 23.0786 27.9392 23.3933C27.7453 23.3679 27.6635 23.1815 27.4881 23.1925C27.5117 23.9441 26.5148 24.3297 25.7988 23.9973Z",
    fill: "url(#paint91_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1997 23.8087C26.5261 23.8087 26.7774 23.7564 26.9629 23.5489C27.1181 23.3802 27.1105 23.187 26.9629 23.009C26.8153 22.831 26.6543 22.7643 26.4476 22.917C26.2098 23.0971 25.9496 23.2454 25.6734 23.3582C25.5343 23.4139 25.5452 23.4696 25.6372 23.5708C25.7091 23.6476 25.7963 23.7084 25.8932 23.7494C25.9901 23.7904 26.0945 23.8106 26.1997 23.8087Z",
    fill: "url(#paint92_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9765 24.0264C29.2068 23.9927 29.4041 23.894 29.3931 23.6139C29.3822 23.3339 29.1992 23.2487 28.9647 23.2014C28.8416 23.177 28.7851 23.1888 28.7817 23.3347C28.7807 23.4673 28.7512 23.598 28.6952 23.7181C28.6392 23.8382 28.5579 23.9448 28.457 24.0307C28.6301 24.0405 28.8036 24.0391 28.9765 24.0264Z",
    fill: "url(#paint93_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3501 30.7148C44.1915 30.7148 44.1494 30.854 44.1426 30.9992C44.1713 31.1729 44.2269 31.3366 44.442 31.3416C44.5929 31.3416 44.7279 31.2775 44.7026 31.0886C44.6748 30.8912 44.5786 30.7166 44.3501 30.7148Z",
    fill: "url(#paint94_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9394 37.3993C38.8673 37.3951 38.7952 37.4056 38.7275 37.4304C38.6597 37.4552 38.5978 37.4935 38.5454 37.5432C38.493 37.5929 38.4514 37.6527 38.4232 37.7191C38.3949 37.7855 38.3806 37.857 38.3811 37.9291C38.3726 38.2539 38.5885 38.496 38.8947 38.5045C39.0492 38.5013 39.1963 38.4378 39.3045 38.3274C39.4127 38.217 39.4733 38.0686 39.4732 37.914C39.4808 37.6103 39.2666 37.4087 38.9394 37.3993Z",
    fill: "url(#paint95_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5169 12.7214C23.632 12.7214 23.7252 12.6281 23.7252 12.5131C23.7252 12.398 23.632 12.3047 23.5169 12.3047C23.4018 12.3047 23.3086 12.398 23.3086 12.5131C23.3086 12.6281 23.4018 12.7214 23.5169 12.7214Z",
    fill: "url(#paint96_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.779 26.4102C67.4762 26.4233 66.1821 26.1958 64.9619 25.7391C63.8349 25.3173 62.8035 24.6745 61.9284 23.8485C61.0774 23.0406 60.4001 22.0675 59.9381 20.9888C58.9946 18.6959 58.9946 16.1231 59.9381 13.8302C60.4015 12.7494 61.083 11.7759 61.94 10.9706C62.8201 10.1467 63.8533 9.50351 64.9811 9.07743C67.4256 8.18252 70.1081 8.18252 72.5528 9.07743C73.6701 9.5038 74.6928 10.1462 75.5616 10.968C76.8644 12.246 77.7518 13.8867 78.1092 15.6763C78.4659 17.4659 78.2761 19.3215 77.5634 21.0016C77.0979 22.081 76.4168 23.054 75.5616 23.8612C74.69 24.6761 73.6679 25.3138 72.5528 25.7391C71.3476 26.1964 70.0677 26.424 68.779 26.4102ZM68.7534 22.9779C69.4896 22.9864 70.2204 22.8513 70.9048 22.5803C71.553 22.3181 72.141 21.9266 72.633 21.4299C73.1329 20.9258 73.524 20.325 73.784 19.6645C74.3312 18.2057 74.3312 16.598 73.784 15.1392C73.524 14.4806 73.1351 13.8805 72.6409 13.3739C72.1517 12.8737 71.5627 12.4818 70.9125 12.2233C70.2234 11.953 69.4885 11.8181 68.7483 11.8258C68.0126 11.8174 67.2822 11.9524 66.5982 12.2233C65.9499 12.4853 65.3617 12.8768 64.8699 13.3739C64.3681 13.8774 63.9745 14.4781 63.713 15.1392C63.1659 16.5936 63.1659 18.1973 63.713 19.6517C63.9704 20.3156 64.3596 20.9205 64.8571 21.4299C65.3461 21.9304 65.935 22.3224 66.5854 22.5803C67.2757 22.8513 68.0119 22.9864 68.7534 22.9779Z",
    fill: "url(#paint97_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9242 12.1533C88.9104 12.1383 89.8859 12.3573 90.7711 12.7924C91.6141 13.2207 92.3046 13.8982 92.7486 14.7329C93.2292 15.6021 93.4698 16.7168 93.4698 18.077V25.7354H89.5901V18.674C89.5901 17.5959 89.3537 16.7999 88.8818 16.286C88.4098 15.7722 87.7423 15.5165 86.8799 15.519C86.3055 15.5094 85.7376 15.641 85.2255 15.9026C84.7306 16.1667 84.3309 16.5799 84.0831 17.0838C83.8095 17.6147 83.6727 18.2965 83.6727 19.1291V25.7431H79.793V12.3527H83.5001V16.0598L82.8032 14.9413C83.2688 14.0619 83.9878 13.3427 84.8666 12.8768C85.8092 12.384 86.8606 12.1352 87.9242 12.1533Z",
    fill: "url(#paint98_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.472 25.9288C100.946 25.9288 99.6071 25.6305 98.4554 25.034C97.3553 24.4818 96.4314 23.6336 95.7875 22.5847C95.1486 21.5147 94.8213 20.2873 94.8428 19.0412C94.8428 17.6972 95.1536 16.5076 95.7746 15.4721C96.3877 14.4441 97.2693 13.6019 98.3236 13.0356C99.4359 12.4637 100.667 12.1612 101.918 12.1525C103.168 12.1439 104.404 12.4293 105.523 12.9858C106.564 13.5306 107.43 14.3578 108.023 15.3724C108.635 16.4086 108.942 17.6478 108.942 19.0897C108.942 19.2393 108.932 19.4093 108.917 19.601C108.902 19.7928 108.884 19.9705 108.867 20.1367H98.0013V17.8715H106.829L105.338 18.5439C105.353 17.9128 105.207 17.2881 104.915 16.7287C104.644 16.2264 104.24 15.8087 103.746 15.522C103.215 15.2234 102.614 15.0733 102.005 15.0873C101.393 15.0741 100.788 15.2241 100.252 15.522C99.751 15.8075 99.3413 16.2301 99.0713 16.7402C98.7777 17.3124 98.6316 17.9493 98.6488 18.5925V19.1894C98.6337 19.8639 98.8013 20.5297 99.1329 21.1172C99.4516 21.6674 99.9279 22.1092 100.501 22.3853C101.15 22.6884 101.86 22.8371 102.576 22.8199C103.218 22.8328 103.855 22.7234 104.454 22.4978C105.006 22.2733 105.508 21.9438 105.933 21.5275L107.998 23.7658C107.364 24.4783 106.569 25.03 105.679 25.3752C104.656 25.7634 103.566 25.9513 102.472 25.9288Z",
    fill: "url(#paint99_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.067 26.026C120.713 26.0313 119.364 25.8428 118.064 25.4662C116.785 25.0929 115.758 24.608 114.98 24.0114L116.348 20.9779C117.161 21.5417 118.053 21.9816 118.996 22.2831C119.993 22.6199 121.039 22.7926 122.092 22.7945C122.888 22.7945 123.531 22.7156 124.019 22.558C124.508 22.4003 124.869 22.1809 125.101 21.8996C125.329 21.6283 125.452 21.284 125.449 20.9294C125.455 20.7142 125.409 20.5008 125.314 20.3077C125.219 20.1147 125.078 19.948 124.903 19.8223C124.465 19.5146 123.977 19.2874 123.46 19.1512C122.863 18.9808 122.204 18.815 121.483 18.654C120.762 18.4929 120.041 18.2981 119.319 18.0698C118.627 17.8504 117.964 17.5501 117.343 17.175C116.751 16.8151 116.252 16.3207 115.888 15.7317C115.515 15.1352 115.328 14.3728 115.328 13.4448C115.32 12.4769 115.601 11.5288 116.136 10.722C116.676 9.90129 117.488 9.24638 118.574 8.75721C119.66 8.26803 121.023 8.02345 122.664 8.02345C123.753 8.0223 124.838 8.151 125.897 8.40691C126.891 8.63423 127.842 9.02285 128.71 9.55744L127.466 12.6165C126.7 12.1722 125.881 11.8256 125.029 11.5848C124.252 11.3659 123.449 11.2528 122.641 11.2486C121.863 11.2486 121.224 11.3398 120.724 11.5222C120.224 11.7046 119.867 11.9406 119.655 12.2304C119.439 12.5213 119.326 12.8755 119.331 13.2377C119.327 13.449 119.375 13.6582 119.47 13.8468C119.566 14.0354 119.706 14.1976 119.879 14.3192C120.315 14.6261 120.803 14.8498 121.321 14.9788C121.918 15.1492 122.577 15.315 123.299 15.476C124.021 15.6371 124.741 15.8276 125.462 16.0475C126.155 16.2514 126.82 16.5441 127.439 16.918C128.032 17.2798 128.531 17.7759 128.897 18.3663C129.27 18.9629 129.456 19.7175 129.456 20.6303C129.462 21.5878 129.176 22.5244 128.635 23.3147C128.088 24.1278 127.272 24.7827 126.186 25.2795C125.101 25.7764 123.728 26.0252 122.067 26.026Z",
    fill: "url(#paint100_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.575 12.3516H130.695V25.7292H134.575V12.3516Z",
    fill: "url(#paint101_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.344 15.6328V12.6479H144.619V15.6328H135.344ZM142.407 25.9271C140.83 25.9271 139.603 25.5253 138.726 24.7216C137.85 23.918 137.41 22.7202 137.409 21.1283V9.39453H141.287V21.0822C141.287 21.6456 141.436 22.0807 141.735 22.3874C142.033 22.6942 142.439 22.8476 142.954 22.8476C143.517 22.8634 144.069 22.6881 144.52 22.3504L145.564 25.086C145.132 25.3853 144.647 25.6021 144.135 25.7251C143.569 25.8638 142.989 25.9316 142.407 25.9271Z",
    fill: "url(#paint102_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.725 26.3116C151.199 26.3116 149.861 26.0133 148.71 25.4168C147.608 24.8662 146.681 24.0177 146.037 22.9675C145.397 21.8977 145.07 20.6703 145.091 19.424C145.091 18.0801 145.402 16.8904 146.024 15.8549C146.637 14.8269 147.519 13.9847 148.573 13.4184C149.685 12.8465 150.916 12.544 152.166 12.5353C153.417 12.5267 154.652 12.8121 155.771 13.3686C156.812 13.9131 157.678 14.7404 158.271 15.7552C158.884 16.7915 159.191 18.0307 159.191 19.4726C159.191 19.6222 159.182 19.7922 159.167 19.9839C159.152 20.1757 159.132 20.3534 159.116 20.5195H148.251V18.2543H157.079L155.586 18.9267C155.601 18.2957 155.457 17.671 155.164 17.1115C154.893 16.6091 154.488 16.1915 153.995 15.9048C153.464 15.6064 152.863 15.4562 152.254 15.4702C151.642 15.4573 151.037 15.6073 150.501 15.9048C150 16.1911 149.59 16.6135 149.319 17.123C149.026 17.6956 148.882 18.3323 148.897 18.9753V19.5723C148.883 20.2467 149.051 20.9126 149.382 21.5C149.7 22.0506 150.177 22.4925 150.75 22.7681C151.399 23.0712 152.11 23.22 152.826 23.2027C153.467 23.2155 154.104 23.1061 154.704 22.8806C155.255 22.6561 155.757 22.3266 156.183 21.9103L158.248 24.1487C157.614 24.8581 156.822 25.4073 155.935 25.7517C154.911 26.1422 153.821 26.3323 152.725 26.3116Z",
    fill: "url(#paint103_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8998 11.2619C73.4789 9.84932 71.612 8.97288 69.6174 8.78172C67.6228 8.59057 65.6236 9.09657 63.9601 10.2135C62.2965 11.3305 61.0715 12.9895 60.4934 14.908C59.9154 16.8265 60.0201 18.8862 60.7897 20.7362C61.5592 22.5863 62.9461 24.1125 64.7143 25.0551C66.4826 25.9976 68.5227 26.2983 70.4877 25.906C72.4525 25.5135 74.2209 24.4524 75.4914 22.903C76.762 21.3536 77.4567 19.4118 77.4567 17.408C77.4524 15.1015 76.5328 12.8908 74.8998 11.2619ZM67.8972 11.9509C67.3579 12.4347 66.892 12.9946 66.5141 13.6127C66.1223 13.4526 65.7494 13.2498 65.4019 13.0081C66.1334 12.4546 66.9908 12.0914 67.8972 11.9509ZM64.929 13.4235C65.3304 13.7166 65.7645 13.962 66.2226 14.1547C65.7676 15.0765 65.5103 16.0832 65.4671 17.1102H63.2288C63.3058 15.7083 63.9137 14.3883 64.929 13.4184V13.4235ZM63.2288 17.7162H65.4671C65.5048 18.6297 65.7147 19.528 66.0859 20.3636C65.5979 20.5831 65.1392 20.8626 64.7206 21.1958C63.8239 20.2491 63.2948 19.0133 63.2288 17.7111V17.7162ZM65.1654 21.6176C65.5315 21.3348 65.9296 21.0962 66.3517 20.9068C66.7521 21.6463 67.2756 22.312 67.8997 22.8755C66.8883 22.7179 65.9412 22.2804 65.1654 21.6125V21.6176ZM68.4507 22.5533C67.8318 22.0276 67.3122 21.395 66.9167 20.6857C67.4132 20.5223 67.9289 20.4252 68.4507 20.3968V22.5533ZM68.4507 19.7909C67.8363 19.8203 67.2293 19.9379 66.6483 20.1398C66.3051 19.3737 66.1095 18.5497 66.0717 17.7111H68.4507V19.7909ZM68.4507 17.1064H66.073C66.1164 16.1512 66.3621 15.2161 66.7941 14.3631C67.3322 14.5363 67.8911 14.6373 68.4558 14.6635L68.4507 17.1064ZM68.4507 14.0576C67.9927 14.0323 67.5392 13.9534 67.0995 13.8224C67.4684 13.2383 67.9241 12.7138 68.4507 12.2666V14.0576ZM71.5187 12.6246C71.7208 12.7403 71.9154 12.8683 72.1016 13.0081C71.7536 13.2496 71.3803 13.4524 70.9882 13.6127C70.6118 12.9945 70.1472 12.4346 69.6089 11.9509L69.7725 11.9791C70.3871 12.0939 70.9779 12.3118 71.52 12.6233L71.5187 12.6246ZM69.0541 12.2666C69.5804 12.7141 70.036 13.2386 70.4053 13.8224C69.9657 13.9534 69.5122 14.0323 69.0541 14.0576V12.2666ZM69.0541 14.6635C69.6189 14.6373 70.1777 14.5363 70.7159 14.3631C71.1479 15.2161 71.3936 16.1512 71.4369 17.1064H69.0592L69.0541 14.6635ZM69.0541 17.7123H71.4318C71.3944 18.5509 71.1993 19.3749 70.8566 20.1411C70.2755 19.9392 69.6685 19.8217 69.0541 19.7921V17.7123ZM69.0541 22.5495V20.3879C69.5759 20.4162 70.0917 20.5133 70.5881 20.6768C70.1934 21.3873 69.6742 22.0213 69.0554 22.5482L69.0541 22.5495ZM69.6051 22.8716C70.2297 22.3069 70.7537 21.6399 71.1544 20.8992C71.5764 21.0885 71.9746 21.3271 72.3408 21.6099C71.5646 22.2767 70.6174 22.7133 69.6063 22.8703L69.6051 22.8716ZM72.7827 21.1919C72.3644 20.8591 71.9064 20.5795 71.419 20.3597C71.7895 19.5239 71.9994 18.6258 72.0377 17.7123H74.276C74.208 19.0123 73.6794 20.2456 72.7841 21.1907L72.7827 21.1919ZM72.0377 17.1013C71.9941 16.0742 71.7364 15.0675 71.2809 14.1458C71.7395 13.9531 72.1739 13.7076 72.5757 13.4146C73.5892 14.3835 74.1972 15.7013 74.276 17.1013H72.0377Z",
    fill: "url(#paint104_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.448 3.67969C131.741 3.67969 131.048 3.8896 130.459 4.28291C129.871 4.6762 129.412 5.23522 129.142 5.88925C128.871 6.54328 128.8 7.26298 128.937 7.95728C129.076 8.65158 129.417 9.28937 129.917 9.78994C130.418 10.2905 131.056 10.6314 131.75 10.7695C132.444 10.9077 133.164 10.8368 133.818 10.5658C134.472 10.2949 135.031 9.83613 135.424 9.24755C135.817 8.65896 136.027 7.96695 136.027 7.25897C136.027 6.30971 135.651 5.39929 134.98 4.72804C134.308 4.05679 133.397 3.67969 132.448 3.67969ZM133.194 8.02597L132.439 9.40533L131.685 8.02597L130.302 7.27437L131.683 6.52012L132.437 5.14081L133.191 6.52012L134.571 7.27437L133.194 8.02597Z",
    fill: "url(#paint105_linear_1631_65293)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1711 35.0078H59.5886C59.3908 35.0078 59.2305 35.1682 59.2305 35.366C59.2305 35.5639 59.3908 35.7242 59.5886 35.7242H94.1711C94.3688 35.7242 94.5292 35.5639 94.5292 35.366C94.5292 35.1682 94.3688 35.0078 94.1711 35.0078Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1711 37.8711H59.5886C59.3908 37.8711 59.2305 38.0315 59.2305 38.2293C59.2305 38.4272 59.3908 38.5875 59.5886 38.5875H94.1711C94.3688 38.5875 94.5292 38.4272 94.5292 38.2293C94.5292 38.0315 94.3688 37.8711 94.1711 37.8711Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1711 40.7344H59.5886C59.3908 40.7344 59.2305 40.8948 59.2305 41.0926C59.2305 41.2905 59.3908 41.4508 59.5886 41.4508H94.1711C94.3688 41.4508 94.5292 41.2905 94.5292 41.0926C94.5292 40.8948 94.3688 40.7344 94.1711 40.7344Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.612 42.2497C102.077 42.2497 101.582 42.1628 101.128 41.989C100.68 41.8085 100.289 41.5578 99.9552 41.2369C99.6271 40.9094 99.37 40.5284 99.1831 40.0939C98.9955 39.6594 98.9023 39.1814 98.9023 38.66C98.9023 38.1386 98.9955 37.6607 99.1831 37.2261C99.37 36.7917 99.6307 36.4139 99.9652 36.0931C100.299 35.7655 100.69 35.5149 101.138 35.341C101.592 35.1606 102.087 35.0703 102.622 35.0703C103.164 35.0703 103.662 35.1639 104.116 35.3511C104.578 35.5316 104.969 35.8023 105.29 36.1633L104.638 36.795C104.37 36.5142 104.069 36.307 103.735 36.1733C103.401 36.0329 103.044 35.9627 102.662 35.9627C102.268 35.9627 101.9 36.0296 101.559 36.1633C101.225 36.297 100.934 36.4841 100.687 36.7248C100.439 36.9654 100.246 37.2529 100.106 37.5871C99.9716 37.9147 99.905 38.2723 99.905 38.66C99.905 39.0477 99.9716 39.4087 100.106 39.7429C100.246 40.0705 100.439 40.3546 100.687 40.5952C100.934 40.8359 101.225 41.0231 101.559 41.1567C101.9 41.2904 102.268 41.3573 102.662 41.3573C103.044 41.3573 103.401 41.2904 103.735 41.1567C104.069 41.0163 104.37 40.8025 104.638 40.515L105.29 41.1467C104.969 41.5077 104.578 41.7818 104.116 41.9689C103.662 42.1561 103.16 42.2497 102.612 42.2497ZM109.81 42.1694V41.0464L109.759 40.8359V38.9207C109.759 38.5129 109.639 38.1987 109.398 37.9781C109.165 37.7509 108.81 37.6372 108.336 37.6372C108.022 37.6372 107.714 37.6907 107.413 37.7977C107.112 37.8979 106.859 38.035 106.651 38.2088L106.25 37.4868C106.524 37.2662 106.852 37.0991 107.233 36.9855C107.621 36.8651 108.025 36.805 108.446 36.805C109.175 36.805 109.737 36.9822 110.13 37.3364C110.525 37.6907 110.722 38.2322 110.722 38.9608V42.1694H109.81ZM108.065 42.2296C107.671 42.2296 107.323 42.1628 107.022 42.0291C106.728 41.8954 106.501 41.7116 106.34 41.4776C106.18 41.2369 106.1 40.9662 106.1 40.6654C106.1 40.378 106.167 40.1173 106.3 39.8833C106.441 39.6494 106.665 39.4622 106.972 39.3218C107.286 39.1814 107.707 39.1112 108.235 39.1112H109.92V39.8031H108.275C107.794 39.8031 107.47 39.8833 107.303 40.0437C107.136 40.2042 107.052 40.398 107.052 40.6253C107.052 40.886 107.156 41.0966 107.363 41.257C107.571 41.4108 107.858 41.4876 108.225 41.4876C108.586 41.4876 108.901 41.4074 109.168 41.247C109.442 41.0865 109.639 40.8526 109.759 40.5451L109.95 41.2069C109.823 41.5211 109.599 41.7717 109.278 41.9589C108.957 42.1394 108.553 42.2296 108.065 42.2296ZM112.503 42.1694V36.8551H113.426V38.299L113.336 37.938C113.483 37.5704 113.73 37.2897 114.078 37.0958C114.426 36.902 114.853 36.805 115.361 36.805V37.7375C115.321 37.7308 115.281 37.7275 115.241 37.7275C115.208 37.7275 115.174 37.7275 115.14 37.7275C114.626 37.7275 114.218 37.8812 113.917 38.1887C113.616 38.4963 113.466 38.9407 113.466 39.5223V42.1694H112.503ZM118.588 42.2296C118.053 42.2296 117.639 42.0859 117.345 41.7984C117.051 41.511 116.904 41.0999 116.904 40.5651V35.692H117.866V40.525C117.866 40.8125 117.936 41.0331 118.077 41.1868C118.224 41.3406 118.431 41.4174 118.699 41.4174C118.999 41.4174 119.25 41.3339 119.451 41.1667L119.751 41.8586C119.604 41.9857 119.427 42.0792 119.22 42.1394C119.019 42.1995 118.809 42.2296 118.588 42.2296ZM116.001 37.6473V36.8551H119.39V37.6473H116.001Z",
    fill: "#16A2FF",
    style: {
      fill: "#16A2FF",
      fill: "color(display-p3 0.0863 0.6353 1.0000)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.833 35.0078H124.251C124.053 35.0078 123.893 35.1682 123.893 35.366C123.893 35.5639 124.053 35.7242 124.251 35.7242H158.833C159.031 35.7242 159.191 35.5639 159.191 35.366C159.191 35.1682 159.031 35.0078 158.833 35.0078Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.833 37.8711H124.251C124.053 37.8711 123.893 38.0315 123.893 38.2293C123.893 38.4272 124.053 38.5875 124.251 38.5875H158.833C159.031 38.5875 159.191 38.4272 159.191 38.2293C159.191 38.0315 159.031 37.8711 158.833 37.8711Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.833 40.7344H124.251C124.053 40.7344 123.893 40.8948 123.893 41.0926C123.893 41.2905 124.053 41.4508 124.251 41.4508H158.833C159.031 41.4508 159.191 41.2905 159.191 41.0926C159.191 40.8948 159.031 40.7344 158.833 40.7344Z",
    fill: "#BDE0EF",
    style: {
      fill: "#BDE0EF",
      fill: "color(display-p3 0.7412 0.8784 0.9373)",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1631_65293",
    x1: 15.9283,
    y1: 18.7373,
    x2: 15.9283,
    y2: 0.0477194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005DE9",
    style: {
      stopColor: "#005DE9",
      stopColor: "color(display-p3 0.0000 0.3647 0.9137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16CFFF",
    style: {
      stopColor: "#16CFFF",
      stopColor: "color(display-p3 0.0863 0.8118 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1631_65293",
    x1: 13.1164,
    y1: 34.1224,
    x2: 13.1164,
    y2: 8.17829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005DE9",
    style: {
      stopColor: "#005DE9",
      stopColor: "color(display-p3 0.0000 0.3647 0.9137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16CFFF",
    style: {
      stopColor: "#16CFFF",
      stopColor: "color(display-p3 0.0863 0.8118 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1631_65293",
    x1: 13.3544,
    y1: 47.9878,
    x2: 13.3544,
    y2: 0.0078125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005DE9",
    style: {
      stopColor: "#005DE9",
      stopColor: "color(display-p3 0.0000 0.3647 0.9137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16CFFF",
    style: {
      stopColor: "#16CFFF",
      stopColor: "color(display-p3 0.0863 0.8118 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1631_65293",
    x1: 35.1647,
    y1: 8.86139,
    x2: 37.6374,
    y2: 4.57883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005DE9",
    style: {
      stopColor: "#005DE9",
      stopColor: "color(display-p3 0.0000 0.3647 0.9137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#0163EA",
    style: {
      stopColor: "#0163EA",
      stopColor: "color(display-p3 0.0039 0.3882 0.9176)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#0474ED",
    style: {
      stopColor: "#0474ED",
      stopColor: "color(display-p3 0.0157 0.4549 0.9294)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#0A8FF3",
    style: {
      stopColor: "#0A8FF3",
      stopColor: "color(display-p3 0.0392 0.5608 0.9529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#11B5FA",
    style: {
      stopColor: "#11B5FA",
      stopColor: "color(display-p3 0.0667 0.7098 0.9804)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16CFFF",
    style: {
      stopColor: "#16CFFF",
      stopColor: "color(display-p3 0.0863 0.8118 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1631_65293",
    x1: 37.2942,
    y1: 11.7686,
    x2: 40.7578,
    y2: 5.76819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005DE9",
    style: {
      stopColor: "#005DE9",
      stopColor: "color(display-p3 0.0000 0.3647 0.9137)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16CFFF",
    style: {
      stopColor: "#16CFFF",
      stopColor: "color(display-p3 0.0863 0.8118 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1631_65293",
    x1: 19.8611,
    y1: 19.2078,
    x2: 36.7964,
    y2: 19.2078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1631_65293",
    x1: 19.3075,
    y1: 35.341,
    x2: 37.448,
    y2: 35.341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1631_65293",
    x1: 36.5641,
    y1: 31.7943,
    x2: 46.7332,
    y2: 31.7943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1631_65293",
    x1: 41.2959,
    y1: 35.9973,
    x2: 46.7726,
    y2: 35.9973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1631_65293",
    x1: 36.7118,
    y1: 27.1806,
    x2: 48.2717,
    y2: 27.1806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1631_65293",
    x1: 28.8949,
    y1: 44.6208,
    x2: 34.5394,
    y2: 44.6208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1631_65293",
    x1: 35.6051,
    y1: 43.0709,
    x2: 40.1617,
    y2: 43.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1631_65293",
    x1: 39.1901,
    y1: 38.9047,
    x2: 41.78,
    y2: 38.9047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1631_65293",
    x1: 30.8694,
    y1: 11.6187,
    x2: 37.8338,
    y2: 11.6187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1631_65293",
    x1: 35.1855,
    y1: 18.7914,
    x2: 43.1822,
    y2: 18.7914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1631_65293",
    x1: 43.1621,
    y1: 22.1945,
    x2: 48.3993,
    y2: 22.1945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1631_65293",
    x1: 42.0075,
    y1: 26.8575,
    x2: 49.1979,
    y2: 26.8575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1631_65293",
    x1: 32.8789,
    y1: 41.7944,
    x2: 36.7356,
    y2: 41.7944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1631_65293",
    x1: 34.1227,
    y1: 17.895,
    x2: 40.6418,
    y2: 17.895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1631_65293",
    x1: 15.9294,
    y1: 41.567,
    x2: 23.1418,
    y2: 41.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1631_65293",
    x1: 22.5485,
    y1: 45.2161,
    x2: 28.5557,
    y2: 45.2161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1631_65293",
    x1: 43.0765,
    y1: 18.2142,
    x2: 46.6219,
    y2: 18.2142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1631_65293",
    x1: 14.8861,
    y1: 35.4671,
    x2: 19.9235,
    y2: 35.4671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1631_65293",
    x1: 37.0916,
    y1: 36.9514,
    x2: 40.5637,
    y2: 36.9514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1631_65293",
    x1: 21.7736,
    y1: 34.3296,
    x2: 27.2732,
    y2: 34.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1631_65293",
    x1: 29.7385,
    y1: 32.1765,
    x2: 35.1368,
    y2: 32.1765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1631_65293",
    x1: 17.9313,
    y1: 33.0377,
    x2: 21.9743,
    y2: 33.0377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1631_65293",
    x1: 36.9334,
    y1: 11.917,
    x2: 39.0426,
    y2: 11.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1631_65293",
    x1: 39.9673,
    y1: 14.3707,
    x2: 42.0968,
    y2: 14.3707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1631_65293",
    x1: 38.9219,
    y1: 25.2487,
    x2: 46.0338,
    y2: 25.2487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1631_65293",
    x1: 30.7719,
    y1: 30.6083,
    x2: 34.8722,
    y2: 30.6083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1631_65293",
    x1: 17.9391,
    y1: 42.1868,
    x2: 23.6031,
    y2: 42.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1631_65293",
    x1: 35.9727,
    y1: 34.8329,
    x2: 38.5609,
    y2: 34.8329,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1631_65293",
    x1: 21.1863,
    y1: 37.6138,
    x2: 25.8712,
    y2: 37.6138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1631_65293",
    x1: 32.7269,
    y1: 14.563,
    x2: 36.748,
    y2: 14.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1631_65293",
    x1: 35.8499,
    y1: 21.3626,
    x2: 41.7146,
    y2: 21.3626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1631_65293",
    x1: 30.4411,
    y1: 41.6177,
    x2: 35.0214,
    y2: 41.6177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1631_65293",
    x1: 23.9224,
    y1: 32.7571,
    x2: 26.3749,
    y2: 32.7571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1631_65293",
    x1: 15.1035,
    y1: 28.6931,
    x2: 17.9793,
    y2: 28.6931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1631_65293",
    x1: 27.7124,
    y1: 33.0947,
    x2: 30.0013,
    y2: 33.0947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1631_65293",
    x1: 20.1381,
    y1: 32.5804,
    x2: 21.6224,
    y2: 32.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1631_65293",
    x1: 37.772,
    y1: 22.8282,
    x2: 41.6337,
    y2: 22.8282,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1631_65293",
    x1: 14.2823,
    y1: 30.1026,
    x2: 18.0158,
    y2: 30.1026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1631_65293",
    x1: 18.9688,
    y1: 35.6126,
    x2: 23.9977,
    y2: 35.6126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1631_65293",
    x1: 16.9665,
    y1: 37.8614,
    x2: 19.8819,
    y2: 37.8614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1631_65293",
    x1: 17.297,
    y1: 28.0649,
    x2: 18.6,
    y2: 28.0649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1631_65293",
    x1: 26.1029,
    y1: 33.1044,
    x2: 28.3226,
    y2: 33.1044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1631_65293",
    x1: 45.8516,
    y1: 31.4269,
    x2: 48.5301,
    y2: 31.4269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_1631_65293",
    x1: 39.4224,
    y1: 24.3341,
    x2: 41.5139,
    y2: 24.3341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1631_65293",
    x1: 18.8848,
    y1: 29.4565,
    x2: 20.5875,
    y2: 29.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_1631_65293",
    x1: 41.7946,
    y1: 40.3283,
    x2: 43.0057,
    y2: 40.3283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1631_65293",
    x1: 15.4924,
    y1: 31.7397,
    x2: 17.9078,
    y2: 31.7397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1631_65293",
    x1: 36.7066,
    y1: 40.2215,
    x2: 39.4079,
    y2: 40.2215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1631_65293",
    x1: 42.2974,
    y1: 14.7787,
    x2: 44.4774,
    y2: 14.7787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1631_65293",
    x1: 43.9395,
    y1: 37.1544,
    x2: 45.2543,
    y2: 37.1544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1631_65293",
    x1: 26.998,
    y1: 45.7866,
    x2: 28.6248,
    y2: 45.7866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1631_65293",
    x1: 46.5508,
    y1: 24.6014,
    x2: 48.9745,
    y2: 24.6014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1631_65293",
    x1: 37.8961,
    y1: 20.0937,
    x2: 40.7795,
    y2: 20.0937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1631_65293",
    x1: 42.3915,
    y1: 17.2346,
    x2: 43.3723,
    y2: 17.2346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1631_65293",
    x1: 38.342,
    y1: 18.142,
    x2: 39.7133,
    y2: 18.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1631_65293",
    x1: 36.9628,
    y1: 34.5162,
    x2: 38.0145,
    y2: 34.5162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1631_65293",
    x1: 35.39,
    y1: 11.1555,
    x2: 36.8634,
    y2: 11.1555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1631_65293",
    x1: 18.2969,
    y1: 41.4517,
    x2: 19.6049,
    y2: 41.4517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1631_65293",
    x1: 14.7226,
    y1: 37.1976,
    x2: 16.7037,
    y2: 37.1976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1631_65293",
    x1: 19.7586,
    y1: 44.4115,
    x2: 21.5397,
    y2: 44.4115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1631_65293",
    x1: 33.5289,
    y1: 19.8823,
    x2: 35.3725,
    y2: 19.8823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1631_65293",
    x1: 36.0076,
    y1: 18.2238,
    x2: 37.1292,
    y2: 18.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1631_65293",
    x1: 19.9914,
    y1: 37.3729,
    x2: 22.3907,
    y2: 37.3729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1631_65293",
    x1: 45.6272,
    y1: 26.7741,
    x2: 46.78,
    y2: 26.7741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1631_65293",
    x1: 41.3594,
    y1: 20.7251,
    x2: 42.5662,
    y2: 20.7251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1631_65293",
    x1: 28.8458,
    y1: 36.9977,
    x2: 29.9944,
    y2: 36.9977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1631_65293",
    x1: 40.248,
    y1: 19.2331,
    x2: 41.406,
    y2: 19.2331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1631_65293",
    x1: 27.4103,
    y1: 42.359,
    x2: 28.3406,
    y2: 42.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1631_65293",
    x1: 33.1339,
    y1: 39.911,
    x2: 34.0776,
    y2: 39.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1631_65293",
    x1: 24.2312,
    y1: 8.9195,
    x2: 25.1648,
    y2: 8.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_1631_65293",
    x1: 34.9983,
    y1: 8.8879,
    x2: 35.8838,
    y2: 8.8879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_1631_65293",
    x1: 26.8259,
    y1: 10.4004,
    x2: 27.746,
    y2: 10.4004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_1631_65293",
    x1: 27.0337,
    y1: 12.4472,
    x2: 27.9352,
    y2: 12.4472,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_1631_65293",
    x1: 27.1465,
    y1: 11.3672,
    x2: 28.0278,
    y2: 11.3672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_1631_65293",
    x1: 26.1521,
    y1: 9.63759,
    x2: 27.0477,
    y2: 9.63759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_1631_65293",
    x1: 25.2554,
    y1: 9.14373,
    x2: 26.151,
    y2: 9.14373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_1631_65293",
    x1: 43.4022,
    y1: 20.6094,
    x2: 44.437,
    y2: 20.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_1631_65293",
    x1: 16.4238,
    y1: 33.2214,
    x2: 17.1778,
    y2: 33.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_1631_65293",
    x1: 25.5695,
    y1: 47.0065,
    x2: 26.2932,
    y2: 47.0065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_1631_65293",
    x1: 41.6621,
    y1: 23.2386,
    x2: 42.352,
    y2: 23.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_1631_65293",
    x1: 33.7207,
    y1: 13.2277,
    x2: 35.2691,
    y2: 13.2277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_1631_65293",
    x1: 38.7891,
    y1: 29.6972,
    x2: 39.4925,
    y2: 29.6972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_1631_65293",
    x1: 24.3392,
    y1: 38.6551,
    x2: 24.9861,
    y2: 38.6551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_1631_65293",
    x1: 25.5099,
    y1: 25.1916,
    x2: 32.492,
    y2: 25.1916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_1631_65293",
    x1: 27.7641,
    y1: 24.0141,
    x2: 31.6318,
    y2: 24.0141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_1631_65293",
    x1: 28.1914,
    y1: 22.7925,
    x2: 28.2008,
    y2: 22.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_1631_65293",
    x1: 25.7988,
    y1: 23.8792,
    x2: 28.463,
    y2: 23.8792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_1631_65293",
    x1: 25.5722,
    y1: 23.3211,
    x2: 27.0768,
    y2: 23.3211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_1631_65293",
    x1: 28.457,
    y1: 23.6148,
    x2: 29.394,
    y2: 23.6148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_1631_65293",
    x1: 44.1426,
    y1: 31.0287,
    x2: 44.706,
    y2: 31.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_1631_65293",
    x1: 38.3811,
    y1: 37.9519,
    x2: 39.4732,
    y2: 37.9519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_1631_65293",
    x1: 23.3086,
    y1: 12.5131,
    x2: 23.7244,
    y2: 12.5131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_1631_65293",
    x1: 68.7534,
    y1: 26.4102,
    x2: 68.7534,
    y2: 8.40627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_1631_65293",
    x1: 86.6321,
    y1: 25.7303,
    x2: 86.6321,
    y2: 12.1533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_1631_65293",
    x1: 101.886,
    y1: 25.9288,
    x2: 101.886,
    y2: 12.1523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_1631_65293",
    x1: 122.217,
    y1: 26.026,
    x2: 122.217,
    y2: 8.02216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_1631_65293",
    x1: 132.635,
    y1: 25.7292,
    x2: 132.635,
    y2: 12.3516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_1631_65293",
    x1: 140.455,
    y1: 25.9271,
    x2: 140.455,
    y2: 9.39074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_1631_65293",
    x1: 152.141,
    y1: 26.3116,
    x2: 152.141,
    y2: 12.5351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_1631_65293",
    x1: 68.7524,
    y1: 26.1109,
    x2: 68.7524,
    y2: 8.70523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_1631_65293",
    x1: 132.448,
    y1: 10.837,
    x2: 132.448,
    y2: 3.67969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#16A2FF",
    style: {
      stopColor: "#16A2FF",
      stopColor: "color(display-p3 0.0863 0.6353 1.0000)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D75DB",
    style: {
      stopColor: "#0D75DB",
      stopColor: "color(display-p3 0.0510 0.4588 0.8588)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1631_65293"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 159,
    height: 47.9865,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(0.5 0.0078125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayHostingFeeLogo);
export default __webpack_public_path__ + "static/media/icon_pay_hosting_fee_logo.71688a9830020c89d264bc0a000a1f09.svg";
export { ForwardRef as ReactComponent };